<template>
  <div>
    <v-container fluid>
      <v-skeleton-loader
        :loading="!flagNav"
        transition="scale-transition"
        max-height="64"
        type="table-heading"
      >
        <v-toolbar :image="SubNavbarBackGround" color="primary" class="header-title text-white">
          <v-toolbar-title class="title" :style="'color: #' + FontColorTitle">{{
            $t("Chat User Management")
          }}</v-toolbar-title>
          <v-spacer />
          <div class="d-flex pr-4">
            <v-toolbar-title class="title" :style="'color: #' + FontColorTitle">{{ today }}</v-toolbar-title>
          </div>
        </v-toolbar>
      </v-skeleton-loader>
      <v-card class="card2" style="margin-top: 1rem">
        <v-card-text>
          <v-row align="center">
            <v-col cols="12" md="12">
              <v-card variant="outlined" class="pa-2 search-panel">
                <v-row no-gutters>
                  <v-col cols="12" md="5" class="pa-2">
                    <v-text-field
                      id="username-field-search-userchatmanagement"
                      :label="$t('username')"
                      density="comfortable"
                      variant="outlined"
                      prepend-inner-icon="mdi-text-box-search-outline"
                      hide-details
                      clearable
                      v-model="username"
                      @keydown.enter="Search"
                      color="primary"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="5" class="pa-2">
                    <v-text-field
                      id="email-field-search-userchatmanagement"
                      :label="$t('email')"
                      v-model="email"
                      density="comfortable"
                      variant="outlined"
                      prepend-inner-icon="mdi-email-outline"
                      hide-details
                      clearable
                      @keydown.enter="Search"
                      color="primary"
                    ></v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    sm="2"
                    class="pa-2 d-flex align-center justify-end"
                  >
                    <v-btn
                      color="primary"
                      class="ml-2"
                      variant="elevated"
                      @click="Search"
                    >
                      <v-icon start>mdi-magnify</v-icon>
                      {{ $t("search") }}
                    </v-btn>
                  </v-col>
                </v-row>
              </v-card>
            </v-col>

            <v-col cols="12" class="d-flex flex-wrap justify-end gap-2">
              <div class="action-controls">
                <!-- Template Button -->
                <v-btn
                  id="button-downloadtemplate-usermanagement"
                  color="info"
                  class="control-btn template-btn"
                  variant="text"
                  size="small"
                  density="comfortable"
                  prepend-icon="mdi-file-export"
                  @click="flagTemplate = true"
                >
                  <span class="btn-text">Template</span>
                  <v-tooltip activator="parent" location="top">
                    Download Template
                  </v-tooltip>
                </v-btn>

                <!-- Import Button -->
                <v-btn
                  id="button-downloadtemplate-usermanagement"
                  color="info"
                  class="control-btn import-btn"
                  variant="text"
                  size="small"
                  density="comfortable"
                  prepend-icon="mdi-table-arrow-left"
                  @click="triggerFileUpload"
                >
                  <span class="btn-text">Import</span>
                  <v-tooltip activator="parent" location="top">
                    Import File
                  </v-tooltip>
                </v-btn>

                <!-- Hidden File Component -->
                <DragDropFile
                  ref="fileUploader"
                  :dialog="true"
                  :DragDrop="false"
                  :ShowListFile="false"
                  :accept="accept"
                  @filesUploaded="processUpload($event)"
                  :allowType="[]"
                  class="d-none"
                />

                <!-- Sync Button -->
                <v-btn
                  v-show="flagShowSync"
                  color="info"
                  class="control-btn sync-btn"
                  variant="text"
                  size="small"
                  density="comfortable"
                  prepend-icon="mdi-sync"
                  @click="SyncUser()"
                >
                  <span class="btn-text">{{ $t("sync") }}</span>
                  <v-tooltip activator="parent" location="top">
                    Sync Users
                  </v-tooltip>
                </v-btn>

                <!-- Divider -->
                <v-divider
                  vertical
                  thickness="1"
                  length="50"
                  class="mx-4"
                ></v-divider>

                <!-- Add User Button -->
                <v-btn
                  id="button-add-usermanagement"
                  color="primary"
                  class="control-btn create-btn"
                  variant="elevated"
                  size="large"
                  prepend-icon="mdi-plus-circle"
                  rounded="xl"
                  @click="
                    Adddialog = true;
                    mailcheck = false;
                    phonecheck = false;
                    GetModel(null);
                    GetGroupModel(null);
                    checkLengthPassword = true;
                    checkLowercaseLetter = true;
                    checkUppercaseLetter = true;
                    checkNumber = true;
                    checkSpecialCharacter = true;
                    checkPasswordMatch = true;
                    user.password = null;
                    user.confirmpassword = null;
                  "
                >
                  <span class="btn-text">{{ $t("add") }}</span>
                  <v-tooltip activator="parent" location="top">
                    Add New User
                  </v-tooltip>
                </v-btn>
              </div>
            </v-col>
          </v-row>
        </v-card-text>
        <v-data-table-server
          :items="filteredUsers"
          :items-per-page="options.itemsPerPage"
          :items-length="searchTotalTable"
          v-model:options="options"
          :headers="headers"
          :loading="loadingTable"
        >
          <template v-slot:item="{ item }">
            <tr>
              <td style="text-align: center">{{ item.number }}</td>
              <td>{{ item.username }}</td>
              <td>{{ item.email }}</td>
              <td>{{ item.mobile }}</td>
              <td>{{ item.fullName }}</td>
              <td style="text-align: center">
                <div class="action-group" style="justify-content: center">
                  <!-- Edit -->
                  <v-btn
                    id="button-edit-popupedit-userchatmanagement"
                    variant="text"
                    density="comfortable"
                    @click="EditUser(item)"
                    class="action-btn edit-btn"
                    icon
                  >
                    <v-icon size="18">mdi-pencil-outline</v-icon>
                    <v-tooltip activator="parent" location="top">
                      Edit
                    </v-tooltip>
                  </v-btn>
                  <!-- Custom Divider -->
                  <div class="action-divider"></div>

                  <!-- Delete -->
                  <v-btn
                    id="button-delete-popupdelete-userchatmanagement"
                    variant="text"
                    density="comfortable"
                    @click="DeleteUser(item.userId)"
                    class="action-btn delete-btn"
                    icon
                  >
                    <v-icon size="18">mdi-delete-outline</v-icon>
                    <v-tooltip activator="parent" location="top">
                      Delete
                    </v-tooltip>
                  </v-btn>
                </div>
              </td>
            </tr>
          </template>
        </v-data-table-server>

        <br />
        <br />
        <br />
      </v-card>
    </v-container>
    <!-- EditUserDialog -->
    <v-dialog
      v-model="Editdialog"
      max-width="800px"
      persistent
      class="modern-dialog"
    >
      <v-card class="dialog-card">
        <div class="dialog-header dialog-header-edit">
          <div class="header-main">
            <div class="header-icon-container">
              <div class="icon-background renew-mode">
                <v-icon size="28" color="white"
                  >mdi-account-edit-outline</v-icon
                >
              </div>
            </div>
            <div class="header-text-content">
              <h2 class="dialog-title">{{ $t("userChatManagement") }}</h2>
              <p class="dialog-subtitle">Edit user chat account information</p>
            </div>
          </div>
          <div class="header-actions">
            <v-btn
              icon
              variant="text"
              color="white"
              @click="Editdialog = false"
              class="close-button"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </div>
        </div>

        <v-divider></v-divider>

        <v-card-text class="edit-user-content">
          <v-container fluid>
            <!-- Basic Information Section -->
            <div class="form-section">
              <div class="section-title">
                <v-icon color="primary" class="mr-2"
                  >mdi-account-outline</v-icon
                >
                Basic Information
              </div>

              <v-row class="form-row">
                <v-col cols="12" md="6">
                  <div class="input-wrapper">
                    <label class="input-label">Username (Read Only)</label>
                    <v-text-field
                      :label="$t('username')"
                      :rules="[rules.required]"
                      v-model="edit.username"
                      variant="outlined"
                      density="compact"
                      hide-details="auto"
                      disabled
                      class="modern-input"
                    >
                      <template v-slot:append-inner>
                        <v-tooltip location="top">
                          <template v-slot:activator="{ props }"> </template>
                          <span>{{ $t("username") }}</span>
                        </v-tooltip>
                      </template>
                    </v-text-field>
                  </div>
                </v-col>
                <v-col cols="12" md="6">
                  <!-- Empty space for layout balance -->
                </v-col>
              </v-row>

              <v-row class="form-row">
                <v-col cols="12" md="6">
                  <div class="input-wrapper">
                    <label class="input-label">First Name *</label>
                    <v-text-field
                      id="firstname-field-popupedit-userchatmanagement"
                      :label="$t('firstname')"
                      :rules="[rules.required]"
                      v-model="edit.firstname"
                      variant="outlined"
                      density="compact"
                      hide-details="auto"
                      placeholder="Enter first name"
                      class="modern-input"
                    >
                      <template v-slot:append-inner>
                        <v-tooltip location="top">
                          <template v-slot:activator="{ props }"> </template>
                          <span>{{ $t("firstname") }}</span>
                        </v-tooltip>
                      </template>
                    </v-text-field>
                  </div>
                </v-col>
                <v-col cols="12" md="6">
                  <div class="input-wrapper">
                    <label class="input-label">Last Name *</label>
                    <v-text-field
                      id="lastname-field-popupedit-userchatmanagement"
                      :label="$t('lastname')"
                      :rules="[rules.required]"
                      v-model="edit.lastname"
                      variant="outlined"
                      density="compact"
                      hide-details="auto"
                      placeholder="Enter last name"
                      class="modern-input"
                    >
                      <template v-slot:append-inner>
                        <v-tooltip location="top">
                          <template v-slot:activator="{ props }"> </template>
                          <span>{{ $t("lastname") }}</span>
                        </v-tooltip>
                      </template>
                    </v-text-field>
                  </div>
                </v-col>
              </v-row>

              <v-row class="form-row">
                <v-col cols="12" md="6">
                  <div class="input-wrapper">
                    <label class="input-label"
                      >Email
                      {{ !edit.isUserFromLine ? "*" : "(Read Only)" }}</label
                    >
                    <v-text-field
                      :label="$t('email')"
                      :rules="emailRules"
                      v-model="edit.email"
                      variant="outlined"
                      density="compact"
                      hide-details="auto"
                      :disabled="!edit.isUserFromLine"
                      placeholder="Enter email address"
                      class="modern-input"
                    >
                      <template v-slot:prepend-inner>
                        <v-icon size="18" color="primary"
                          >mdi-email-outline</v-icon
                        >
                      </template>
                      <template v-slot:append-inner>
                        <v-tooltip location="top">
                          <template v-slot:activator="{ props }"> </template>
                          <span>{{ $t("email") }}</span>
                        </v-tooltip>
                      </template>
                    </v-text-field>
                  </div>
                </v-col>
                <v-col cols="12" md="6">
                  <div class="input-wrapper">
                    <label class="input-label">Phone Number</label>
                    <v-text-field
                      id="phonenumber-field-popupedit-userchatmanagement"
                      :label="$t('phonenumber')"
                      v-model="edit.phone"
                      v-mask="mask"
                      variant="outlined"
                      density="compact"
                      hide-details="auto"
                      placeholder="Enter phone number"
                      class="modern-input"
                    >
                      <template v-slot:prepend-inner>
                        <v-icon size="18" color="primary"
                          >mdi-phone-outline</v-icon
                        >
                      </template>
                      <template v-slot:append-inner>
                        <v-tooltip location="top">
                          <template v-slot:activator="{ props }"> </template>
                          <span>{{ $t("phonenumber") }}</span>
                        </v-tooltip>
                      </template>
                    </v-text-field>
                  </div>
                </v-col>
              </v-row>
            </div>

            <v-divider class="section-divider"></v-divider>

            <!-- Integration Social Section -->
            <div class="form-section">
              <div class="section-title">
                <v-icon color="primary" class="mr-2"
                  >mdi-share-variant-outline</v-icon
                >
                Integration Social
              </div>

              <v-row class="form-row">
                <v-col cols="12" md="6">
                  <div class="input-wrapper">
                    <label class="input-label">Social User ID</label>
                    <v-text-field
                      id="socialuserid-line-field-userchatmanagement"
                      ref="socialUserID"
                      :label="$t('SocialUserID')"
                      v-model="edit.socialUserID"
                      variant="outlined"
                      density="compact"
                      hide-details="auto"
                      placeholder="Enter social user ID"
                      class="modern-input"
                    >
                      <template v-slot:prepend-inner>
                        <LineIcon
                          :size="18"
                          :opacity="0.7"
                          color="rgb(var(--v-theme-primary))"
                        />
                      </template>
                      <template v-slot:append-inner>
                        <v-tooltip location="top">
                          <template v-slot:activator="{ props }"> </template>
                          <span>{{ $t("SocialUserID") }}</span>
                        </v-tooltip>
                      </template>
                    </v-text-field>
                  </div>
                </v-col>
                <v-col cols="12" md="6">
                  <div class="input-wrapper">
                    <label class="input-label">Recipient ID (Facebook)</label>
                    <v-text-field
                      id="recipientId-facebook-field-userchatmanagement"
                      ref="recipientId"
                      :label="$t('RecipientId')"
                      v-model="edit.recipientId"
                      variant="outlined"
                      density="compact"
                      hide-details="auto"
                      placeholder="Enter Facebook recipient ID"
                      class="modern-input"
                    >
                      <template v-slot:prepend-inner>
                        <v-icon size="18" color="primary">mdi-facebook</v-icon>
                      </template>
                      <template v-slot:append-inner>
                        <v-tooltip location="top">
                          <template v-slot:activator="{ props }"> </template>
                          <span>{{ $t("RecipientId") }}</span>
                        </v-tooltip>
                      </template>
                    </v-text-field>
                  </div>
                </v-col>
              </v-row>

              <v-row class="form-row">
                <v-col cols="12" md="6">
                  <div class="input-wrapper">
                    <label class="input-label">Recipient ID (Instagram)</label>
                    <v-text-field
                      id="recipientId-instagram-field-userchatmanagement"
                      ref="recipientId_Instagram"
                      :label="$t('RecipientId_Instagram')"
                      v-model="edit.recipientId_Instagram"
                      variant="outlined"
                      density="compact"
                      hide-details="auto"
                      placeholder="Enter Instagram recipient ID"
                      class="modern-input"
                    >
                      <template v-slot:prepend-inner>
                        <v-icon size="18" color="primary">mdi-instagram</v-icon>
                      </template>
                      <template v-slot:append-inner>
                        <v-tooltip location="top">
                          <template v-slot:activator="{ props }"> </template>
                          <span>{{ $t("RecipientId_Instagram") }}</span>
                        </v-tooltip>
                      </template>
                    </v-text-field>
                  </div>
                </v-col>
              </v-row>
            </div>

            <v-divider class="section-divider"></v-divider>

            <!-- Model Section -->
            <div class="form-section">
              <div class="section-title">
                <v-icon color="primary" class="mr-2">mdi-robot-outline</v-icon>
                Model Configuration
              </div>

              <v-row class="form-row">
                <v-col cols="12" md="6">
                  <div class="input-wrapper">
                    <label class="input-label">Model Grouping</label>
                    <v-autocomplete
                      id="modelgrouping-autocomplete-userchatmanagement"
                      :label="'Model Grouping'"
                      :items="listDDGroupModel"
                      item-title="name"
                      item-value="id"
                      clearable
                      variant="outlined"
                      density="compact"
                      hide-details="auto"
                      v-model="edit.groupModel"
                      placeholder="Select model grouping"
                      class="modern-input"
                    >
                      <template v-slot:item="{ props, item, index }">
                        <v-list-item 
                          v-bind="props"
                          :id="'modelgrouping-edit-userchatmanagement-option-' + index" 
                          :value="item.raw.name"
                        >
                          <template v-slot:title>
                            <span>{{ item.raw.name }}</span>
                          </template>
                        </v-list-item>
                      </template>
                      <template v-slot:prepend-inner>
                        <v-icon size="18" color="primary">mdi-group</v-icon>
                      </template>
                      <template v-slot:append-inner>
                        <v-tooltip location="top">
                          <template v-slot:activator="{ props }"> </template>
                          <span>{{ $t("_InfoSelectGroupModel") }}</span>
                        </v-tooltip>
                      </template>
                    </v-autocomplete>
                  </div>
                </v-col>
                <v-col cols="12" md="6">
                  <div class="input-wrapper">
                    <label class="input-label">Model</label>
                    <v-autocomplete
                      id="model-autocomplete-userchatmanagement"
                      :label="'Model'"
                      :items="listDDModel"
                      chips
                      closable-chips
                      item-title="name"
                      item-value="modelDisplayID"
                      multiple
                      clearable
                      variant="outlined"
                      density="compact"
                      hide-details="auto"
                      v-model="edit.model"
                      placeholder="Select available models"
                      class="modern-input"
                    >
                      <template v-slot:item="{ props, item, index }">
                        <v-list-item 
                          v-bind="props"
                          :id="'model-edit-userchatmanagement-option-' + index" 
                          :value="item.raw.name"
                        >
                          <template v-slot:title>
                            <span>{{ item.raw.name }}</span>
                          </template>
                        </v-list-item>
                      </template>
                      <template v-slot:prepend-inner>
                        <v-icon size="18" color="primary">mdi-robot</v-icon>
                      </template>
                      <template v-slot:append-inner>
                        <v-tooltip location="top">
                          <template v-slot:activator="{ props }"> </template>
                          <span>{{ $t("_InfoSelectModel") }}</span>
                        </v-tooltip>
                      </template>
                    </v-autocomplete>
                  </div>
                </v-col>
              </v-row>

              <v-row class="form-row">
                <v-col cols="12" md="6">
                  <div class="input-wrapper">
                    <label class="input-label">Model Shortcut</label>
                    <v-autocomplete
                      id="modelshortcut-autocomplete-userchatmanagement"
                      :label="'Model Shortcut'"
                      :items="DDQuickModel"
                      item-title="name"
                      item-value="id"
                      clearable
                      variant="outlined"
                      density="compact"
                      hide-details="auto"
                      v-model="edit.modelQuickGroupID"
                      placeholder="Select model shortcut"
                      class="modern-input"
                    >
                      <template v-slot:item="{ props, item, index }">
                        <v-list-item 
                          v-bind="props"
                          :id="'modelshortcut-edit-userchatmanagement-option-' + index" 
                          :value="item.raw.name"
                        >
                          <template v-slot:title>
                            <span>{{ item.raw.name }}</span>
                          </template>
                        </v-list-item>
                      </template>
                      <template v-slot:prepend-inner>
                        <v-icon size="18" color="primary">mdi-flash</v-icon>
                      </template>
                      <template v-slot:append-inner>
                        <v-tooltip location="top">
                          <template v-slot:activator="{ props }"> </template>
                          <span>{{ $t("_InfoSelectQuickModel") }}</span>
                        </v-tooltip>
                      </template>
                    </v-autocomplete>
                  </div>
                </v-col>
              </v-row>
            </div>

            <v-divider class="section-divider"></v-divider>

            <!-- Lock Status Section -->
            <div class="form-section">
              <div class="section-title">
                <v-icon color="primary" class="mr-2"
                  >mdi-shield-account-outline</v-icon
                >
                Account Settings
              </div>

              <v-row class="form-row">
                <v-col cols="12">
                  <div class="switch-wrapper">
                    <div class="switch-content">
                      <div class="switch-info">
                        <div class="lock-icon-container">
                          <v-icon
                            :color="edit.lockStatus ? 'error' : 'success'"
                            class="lock-icon"
                            :class="{
                              locked: edit.lockStatus,
                              unlocked: !edit.lockStatus,
                            }"
                          >
                            {{ edit.lockStatus ? "mdi-lock" : "mdi-lock-open" }}
                          </v-icon>
                        </div>
                        <div>
                          <div class="switch-title">
                            {{ $t("_LockStatus") }}
                          </div>
                          <div class="switch-subtitle">
                            {{
                              edit.lockStatus
                                ? "Account is currently locked and cannot access the system"
                                : "Account is unlocked and can access the system"
                            }}
                          </div>
                        </div>
                      </div>
                      <div class="switch-control">
                        <v-switch
                          id="switch-lockstatus-popupedit-userchatmanagement"
                          v-model="edit.lockStatus"
                          color="error"
                          hide-details
                          inset
                          class="modern-switch"
                        >
                          <template v-slot:label>
                            <span
                              class="switch-label"
                              :class="{
                                'locked-text': edit.lockStatus,
                                'unlocked-text': !edit.lockStatus,
                              }"
                            >
                              {{
                                edit.lockStatus
                                  ? $t("_Locked")
                                  : $t("_Unlocked")
                              }}
                            </span>
                          </template>
                        </v-switch>
                      </div>
                    </div>
                  </div>
                </v-col>
              </v-row>
            </div>
          </v-container>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions class="dialog-actions">
          <div class="actions-content">
            <div class="actions-left">
              <v-btn
                id="button-changepassword-popupedit-userchatmanagement"
                variant="outlined"
                color="blue"
                @click="
                  changPasswordDialog = true;
                  edit.password = null;
                  edit.confirmpassword = null;
                  checkLengthPassword = true;
                  checkLowercaseLetter = true;
                  checkUppercaseLetter = true;
                  checkNumber = true;
                  checkSpecialCharacter = true;
                  checkPasswordMatch = true;
                "
                class="dialog-action-btn"
              >
                <v-icon start>mdi-lock-reset</v-icon>
                Change Password
              </v-btn>
            </div>
            <div class="actions-right">
              <v-btn
                variant="outlined"
                color="grey"
                @click="Editdialog = false"
                class="dialog-action-btn cancel-btn"
              >
                <v-icon class="mr-2">mdi-close</v-icon>
                {{ $t("close") }}
              </v-btn>
              <v-btn
                id="button-save-popupedit-userchatmanagement"
                variant="elevated"
                @click="UpdateUser"
                class="dialog-action-btn save-btn-edit"
              >
                <v-icon start>mdi-content-save</v-icon>
                {{ $t("save") }}
              </v-btn>
            </div>
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- AddUserDialog -->
    <v-dialog
      ref="form"
      v-model="Adddialog"
      max-width="800px"
      persistent
      class="modern-dialog"
    >
      <v-card class="dialog-card">
        <div class="dialog-header dialog-header-add">
          <div class="header-main">
            <div class="header-icon-container">
              <div class="icon-background add-mode">
                <v-icon size="28" color="white"
                  >mdi-account-plus-outline</v-icon
                >
              </div>
            </div>
            <div class="header-text-container">
              <h2 class="dialog-title">Add New Chat User</h2>
              <p class="dialog-subtitle">
                Create a new user chat account with required information
              </p>
            </div>
          </div>
          <div class="header-actions">
            <v-btn
              icon
              variant="text"
              color="white"
              @click="closeadd"
              class="close-button"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </div>
        </div>

        <v-divider></v-divider>

        <v-card-text class="add-user-content">
          <v-container fluid>
            <!-- Basic Information Section -->
            <div class="form-section">
              <div class="section-title">
                <v-icon color="primary" class="mr-2"
                  >mdi-account-outline</v-icon
                >
                Basic Information
              </div>

              <v-row class="form-row">
                <v-col cols="12">
                  <div class="input-wrapper">
                    <label class="input-label">Username *</label>
                    <v-text-field
                      id="username-field-add-userchatmanagement"
                      ref="username"
                      v-model="user.username"
                      :rules="[rules.required]"
                      variant="outlined"
                      density="compact"
                      hide-details="auto"
                      placeholder="Enter username"
                      class="modern-input"
                    >
                      <template v-slot:append-inner>
                        <v-tooltip location="top">
                          <template v-slot:activator="{ props }"> </template>
                          <span>{{ $t("username") }}</span>
                        </v-tooltip>
                      </template>
                    </v-text-field>
                  </div>
                </v-col>
              </v-row>

              <v-row class="form-row">
                <v-col cols="12" md="6">
                  <div class="input-wrapper">
                    <label class="input-label">First Name *</label>
                    <v-text-field
                      id="firstname-field-add-userchatmanagement"
                      ref="firstname"
                      v-model="user.firstname"
                      :rules="[rules.required]"
                      variant="outlined"
                      density="compact"
                      hide-details="auto"
                      placeholder="Enter first name"
                      class="modern-input"
                    >
                    </v-text-field>
                  </div>
                </v-col>
                <v-col cols="12" md="6">
                  <div class="input-wrapper">
                    <label class="input-label">Last Name *</label>
                    <v-text-field
                      id="lastname-field-add-userchatmanagement"
                      ref="lastname"
                      v-model="user.lastname"
                      :rules="[rules.required]"
                      variant="outlined"
                      density="compact"
                      hide-details="auto"
                      placeholder="Enter last name"
                      class="modern-input"
                    >
                    </v-text-field>
                  </div>
                </v-col>
              </v-row>

              <v-row class="form-row">
                <v-col cols="12" md="6">
                  <div class="input-wrapper">
                    <label class="input-label">Email *</label>
                    <v-text-field
                      id="email-field-add-userchatmanagement"
                      ref="email"
                      v-model="user.email"
                      :rules="[rules.required, validateEmail(user.email)]"
                      variant="outlined"
                      density="compact"
                      hide-details="auto"
                      placeholder="Enter email address"
                      class="modern-input"
                    >
                      <template v-slot:prepend-inner>
                        <v-icon size="18" color="primary"
                          >mdi-email-outline</v-icon
                        >
                      </template>
                    </v-text-field>
                  </div>
                </v-col>
                <v-col cols="12" md="6">
                  <div class="input-wrapper">
                    <label class="input-label">Phone Number</label>
                    <v-text-field
                      id="phone-field-add-userchatmanagement"
                      ref="phone"
                      v-model="user.phone"
                      v-mask="mask"
                      variant="outlined"
                      density="compact"
                      hide-details="auto"
                      placeholder="Enter phone number"
                      class="modern-input"
                    >
                      <template v-slot:prepend-inner>
                        <v-icon size="18" color="primary"
                          >mdi-phone-outline</v-icon
                        >
                      </template>
                    </v-text-field>
                  </div>
                </v-col>
              </v-row>
            </div>

            <v-divider class="section-divider"></v-divider>

            <!-- Password Section -->
            <div class="form-section">
              <div class="section-title">
                <v-icon color="primary" class="mr-2">mdi-lock-outline</v-icon>
                Password Setup
              </div>

              <v-row class="form-row">
                <v-col cols="12" md="6">
                  <div class="input-wrapper">
                    <label class="input-label">Password *</label>
                    <v-text-field
                      id="password-field-add-userchatmanagement"
                      ref="password"
                      v-model="user.password"
                      :rules="[rules.required]"
                      :type="show1 ? 'text' : 'password'"
                      variant="outlined"
                      density="compact"
                      hide-details="auto"
                      placeholder="Enter password"
                      class="modern-input"
                    >
                      <template v-slot:append-inner>
                        <v-btn
                          @click="show1 = !show1"
                          icon
                          variant="text"
                          size="small"
                          class="password-toggle"
                        >
                          <v-icon size="18">{{
                            show1 ? "mdi-eye" : "mdi-eye-off"
                          }}</v-icon>
                        </v-btn>
                      </template>
                    </v-text-field>

                    <!-- Password Requirements -->
                    <div class="password-requirements" v-if="user.password">
                      <div
                        class="requirement-item"
                        :class="{ valid: checkLengthPassword }"
                      >
                        <v-icon
                          size="12"
                          :color="checkLengthPassword ? 'success' : 'error'"
                        >
                          {{ checkLengthPassword ? "mdi-check" : "mdi-close" }}
                        </v-icon>
                        <span>At least 8 characters</span>
                      </div>
                      <div
                        class="requirement-item"
                        :class="{ valid: checkLowercaseLetter }"
                      >
                        <v-icon
                          size="12"
                          :color="checkLowercaseLetter ? 'success' : 'error'"
                        >
                          {{ checkLowercaseLetter ? "mdi-check" : "mdi-close" }}
                        </v-icon>
                        <span>Lowercase letter</span>
                      </div>
                      <div
                        class="requirement-item"
                        :class="{ valid: checkUppercaseLetter }"
                      >
                        <v-icon
                          size="12"
                          :color="checkUppercaseLetter ? 'success' : 'error'"
                        >
                          {{ checkUppercaseLetter ? "mdi-check" : "mdi-close" }}
                        </v-icon>
                        <span>Uppercase letter</span>
                      </div>
                      <div
                        class="requirement-item"
                        :class="{ valid: checkNumber }"
                      >
                        <v-icon
                          size="12"
                          :color="checkNumber ? 'success' : 'error'"
                        >
                          {{ checkNumber ? "mdi-check" : "mdi-close" }}
                        </v-icon>
                        <span>Number</span>
                      </div>
                      <div
                        class="requirement-item"
                        :class="{ valid: checkSpecialCharacter }"
                      >
                        <v-icon
                          size="12"
                          :color="checkSpecialCharacter ? 'success' : 'error'"
                        >
                          {{
                            checkSpecialCharacter ? "mdi-check" : "mdi-close"
                          }}
                        </v-icon>
                        <span>Special character</span>
                      </div>
                    </div>
                  </div>
                </v-col>
                <v-col cols="12" md="6">
                  <div class="input-wrapper">
                    <label class="input-label">Confirm Password *</label>
                    <v-text-field
                      id="confirmpassword-field-add-userchatmanagement"
                      ref="confirmpassword"
                      v-model="user.confirmpassword"
                      :rules="[rules.required]"
                      :type="show2 ? 'text' : 'password'"
                      variant="outlined"
                      density="compact"
                      hide-details="auto"
                      placeholder="Confirm password"
                      class="modern-input"
                    >
                      <template v-slot:append-inner>
                        <v-btn
                          @click="show2 = !show2"
                          icon
                          variant="text"
                          size="small"
                          class="password-toggle"
                        >
                          <v-icon size="18">{{
                            show2 ?  "mdi-eye" : "mdi-eye-off"
                          }}</v-icon>
                        </v-btn>
                      </template>
                    </v-text-field>

                    <!-- Password Match Indicator -->
                    <div class="password-match" v-if="user.confirmpassword">
                      <div
                        class="requirement-item"
                        :class="{ valid: checkPasswordMatch }"
                      >
                        <v-icon
                          size="12"
                          :color="checkPasswordMatch ? 'success' : 'error'"
                        >
                          {{ checkPasswordMatch ? "mdi-check" : "mdi-close" }}
                        </v-icon>
                        <span>Passwords match</span>
                      </div>
                    </div>
                  </div>
                </v-col>
              </v-row>
            </div>

            <v-divider class="section-divider"></v-divider>

            <!-- Integration Social Section -->
            <div class="form-section">
              <div class="section-title">
                <v-icon color="primary" class="mr-2"
                  >mdi-share-variant-outline</v-icon
                >
                Integration Social
              </div>

              <v-row class="form-row">
                <v-col cols="12" md="6">
                  <div class="input-wrapper">
                    <label class="input-label">Social User ID</label>
                    <v-text-field
                      id="socialUserID-line-field-add-userchatmanagement"
                      ref="socialUserID"
                      :label="$t('SocialUserID')"
                      v-model="user.socialUserID"
                      variant="outlined"
                      density="compact"
                      hide-details="auto"
                      placeholder="Enter social user ID"
                      class="modern-input"
                    >
                      <template v-slot:prepend-inner>
                        <LineIcon
                          :size="18"
                          :opacity="0.7"
                          color="rgb(var(--v-theme-primary))"
                        />
                      </template>
                      <template v-slot:append-inner>
                        <v-tooltip location="top">
                          <template v-slot:activator="{ props }"> </template>
                          <span>{{ $t("SocialUserID") }}</span>
                        </v-tooltip>
                      </template>
                    </v-text-field>
                  </div>
                </v-col>
                <v-col cols="12" md="6">
                  <div class="input-wrapper">
                    <label class="input-label">Recipient ID (Facebook)</label>
                    <v-text-field
                      id="recipientId-facebook-field-add-userchatmanagement"
                      ref="recipientId"
                      :label="$t('RecipientId')"
                      v-model="user.recipientId"
                      variant="outlined"
                      density="compact"
                      hide-details="auto"
                      placeholder="Enter Facebook recipient ID"
                      class="modern-input"
                    >
                      <template v-slot:prepend-inner>
                        <v-icon size="18" color="primary">mdi-facebook</v-icon>
                      </template>
                      <template v-slot:append-inner>
                        <v-tooltip location="top">
                          <template v-slot:activator="{ props }"> </template>
                          <span>{{ $t("RecipientId") }}</span>
                        </v-tooltip>
                      </template>
                    </v-text-field>
                  </div>
                </v-col>
              </v-row>

              <v-row class="form-row">
                <v-col cols="12" md="6">
                  <div class="input-wrapper">
                    <label class="input-label">Recipient ID (Instagram)</label>
                    <v-text-field
                      id="recipientId-instagram-field-add-userchatmanagement"
                      ref="recipientId_Instagram"
                      :label="$t('RecipientId_Instagram')"
                      v-model="user.recipientId_Instagram"
                      variant="outlined"
                      density="compact"
                      hide-details="auto"
                      placeholder="Enter Instagram recipient ID"
                      class="modern-input"
                    >
                      <template v-slot:prepend-inner>
                        <v-icon size="18" color="primary">mdi-instagram</v-icon>
                      </template>
                      <template v-slot:append-inner>
                        <v-tooltip location="top">
                          <template v-slot:activator="{ props }"> </template>
                          <span>{{ $t("RecipientId_Instagram") }}</span>
                        </v-tooltip>
                      </template>
                    </v-text-field>
                  </div>
                </v-col>
              </v-row>
            </div>

            <v-divider class="section-divider"></v-divider>

            <!-- Model Section -->
            <div class="form-section">
              <div class="section-title">
                <v-icon color="primary" class="mr-2">mdi-robot-outline</v-icon>
                Model Configuration
              </div>

              <v-row class="form-row">
                <v-col cols="12" md="6">
                  <div class="input-wrapper">
                    <label class="input-label">Model Grouping</label>
                    <v-autocomplete
                      id="modelGrouping-autocomplete-add-userchatmanagement"
                      ref="groupModel"
                      :label="'Model Grouping'"
                      :items="listDDGroupModel"
                      item-title="name"
                      item-value="id"
                      clearable
                      variant="outlined"
                      density="compact"
                      hide-details="auto"
                      v-model="user.groupModel"
                      placeholder="Select model grouping"
                      class="modern-input"
                    >
                      <template v-slot:item="{ props, item, index }">
                        <v-list-item 
                          v-bind="props"
                          :id="'modelgrouping-add-userchatmanagement-option-' + index" 
                          :value="item.raw.name"
                        >
                          <template v-slot:title>
                            <span>{{ item.raw.name }}</span>
                          </template>
                        </v-list-item>
                      </template>
                      <template v-slot:prepend-inner>
                        <v-icon size="18" color="primary">mdi-group</v-icon>
                      </template>
                      <template v-slot:append-inner>
                        <v-tooltip location="top">
                          <template v-slot:activator="{ props }"> </template>
                          <span>{{ $t("_InfoSelectGroupModel") }}</span>
                        </v-tooltip>
                      </template>
                    </v-autocomplete>
                  </div>
                </v-col>
                <v-col cols="12" md="6">
                  <div class="input-wrapper">
                    <label class="input-label">Model</label>
                    <v-autocomplete
                      id="model-autocomplete-add-userchatmanagement"
                      ref="model"
                      :label="'Model'"
                      :items="listDDModel"
                      chips
                      closable-chips
                      item-title="name"
                      item-value="modelDisplayID"
                      multiple
                      clearable
                      variant="outlined"
                      density="compact"
                      hide-details="auto"
                      v-model="user.model"
                      placeholder="Select available models"
                      class="modern-input"
                    >
                      <template v-slot:item="{ props, item, index }">
                        <v-list-item 
                          v-bind="props"
                          :id="'model-add-userchatmanagement-option-' + index" 
                          :value="item.raw.name"
                        >
                          <template v-slot:title>
                            <span>{{ item.raw.name }}</span>
                          </template>
                        </v-list-item>
                      </template>
                      <template v-slot:prepend-inner>
                        <v-icon size="18" color="primary">mdi-robot</v-icon>
                      </template>
                      <template v-slot:append-inner>
                        <v-tooltip location="top">
                          <template v-slot:activator="{ props }"> </template>
                          <span>{{ $t("_InfoSelectModel") }}</span>
                        </v-tooltip>
                      </template>
                    </v-autocomplete>
                  </div>
                </v-col>
              </v-row>

              <v-row class="form-row">
                <v-col cols="12" md="6">
                  <div class="input-wrapper">
                    <label class="input-label">Model Shortcut</label>
                    <v-autocomplete
                      id="modelShortcut-autocomplete-add-userchatmanagement"
                      ref="modelQuickGroupID"
                      :label="'Model Shortcut'"
                      :items="DDQuickModel"
                      item-title="name"
                      item-value="id"
                      clearable
                      variant="outlined"
                      density="compact"
                      hide-details="auto"
                      v-model="user.modelQuickGroupID"
                      placeholder="Select model shortcut"
                      class="modern-input"
                    >
                      <template v-slot:item="{ props, item, index }">
                        <v-list-item 
                          v-bind="props"
                          :id="'modelshortcut-add-userchatmanagement-option-' + index" 
                          :value="item.raw.name"
                        >
                          <template v-slot:title>
                            <span>{{ item.raw.name }}</span>
                          </template>
                        </v-list-item>
                      </template>
                      <template v-slot:prepend-inner>
                        <v-icon size="18" color="primary">mdi-flash</v-icon>
                      </template>
                      <template v-slot:append-inner>
                        <v-tooltip location="top">
                          <template v-slot:activator="{ props }"> </template>
                          <span>{{ $t("_InfoSelectQuickModel") }}</span>
                        </v-tooltip>
                      </template>
                    </v-autocomplete>
                  </div>
                </v-col>
              </v-row>
            </div>

            <v-divider class="section-divider"></v-divider>

            <!-- Lock Status Section -->
            <div class="form-section">
              <div class="section-title">
                <v-icon color="primary" class="mr-2"
                  >mdi-shield-account-outline</v-icon
                >
                Account Settings
              </div>

              <v-row class="form-row">
                <v-col cols="12">
                  <div class="switch-wrapper">
                    <div class="switch-content">
                      <div class="switch-info">
                        <div class="lock-icon-container">
                          <v-icon
                            :color="user.lockStatus ? 'error' : 'success'"
                            class="lock-icon"
                            :class="{
                              locked: user.lockStatus,
                              unlocked: !user.lockStatus,
                            }"
                          >
                            {{ user.lockStatus ? "mdi-lock" : "mdi-lock-open" }}
                          </v-icon>
                        </div>
                        <div>
                          <div class="switch-title">
                            {{ $t("_LockStatus") }}
                          </div>
                          <div class="switch-subtitle">
                            {{
                              user.lockStatus
                                ? "New account will be locked and cannot access the system"
                                : "New account will be unlocked and can access the system"
                            }}
                          </div>
                        </div>
                      </div>
                      <div class="switch-control">
                        <v-switch
                          id="switch-lockstatus-add-userchatmanagement"
                          v-model="user.lockStatus"
                          color="error"
                          hide-details
                          inset
                          class="modern-switch"
                        >
                          <template v-slot:label>
                            <span
                              class="switch-label"
                              :class="{
                                'locked-text': user.lockStatus,
                                'unlocked-text': !user.lockStatus,
                              }"
                            >
                              {{
                                user.lockStatus
                                  ? $t("_Locked")
                                  : $t("_Unlocked")
                              }}
                            </span>
                          </template>
                        </v-switch>
                      </div>
                    </div>
                  </div>
                </v-col>
              </v-row>
            </div>
          </v-container>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions class="add-user-actions">
          <v-spacer></v-spacer>
          <v-btn
            id="button-close-add-userchatmanagement"
            variant="outlined"
            color="grey"
            @click="closeadd"
            class="dialog-action-btn cancel-btn"
          >
            <v-icon start>mdi-close</v-icon>
            {{ $t("close") }}
          </v-btn>
          <v-btn
            id="button-save-add-userchatmanagement"
            variant="elevated"
            @click="AddUser"
            class="dialog-action-btn save-btn-add"
          >
            <v-icon start>mdi-content-save</v-icon>
            {{ $t("save") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Loading Please Wait --> 
    <!-- <v-overlay v-model="dialog">
      <v-dialog v-model="dialog" persistent width="300">
        <v-card color="#1976D2" dark>
          <v-card-text class="white--text">
            Loading Please Wait...
            <v-progress-linear
              indeterminate
              color="#FAA91B"
              class="mb-0"
            ></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-overlay> -->
    <v-overlay :model-value="dialog" class="align-center justify-center">
      <v-card class="loading-card" elevation="8">
        <v-card-text class="text-center">
          <v-progress-circular
            indeterminate
            size="64"
            color="primary"
            class="mb-4"
          ></v-progress-circular>
          <h3 class="loading-title">Loading...</h3>
          <p class="loading-subtitle">Please wait</p>
        </v-card-text>
      </v-card>
    </v-overlay>

    <v-dialog v-model="flagTemplate" max-width="900px" persistent>
      <v-card class="template-dialog">
        <v-card-title class="template-header">
          <div class="header-content">
            <v-icon class="header-icon">mdi-file-download-outline</v-icon>
            <div class="header-text">
              <h2 class="dialog-title">Template User</h2>
              <p class="dialog-subtitle">
                Download template files for user import
              </p>
            </div>
          </div>
          <v-btn
            icon
            variant="text"
            size="small"
            @click="flagTemplate = false"
            class="close-btn"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-divider></v-divider>

        <v-card-text class="template-content">
          <div class="template-description">
            <v-alert type="info" variant="tonal" class="mb-4" density="compact">
              <template v-slot:prepend>
                <v-icon>mdi-information-outline</v-icon>
              </template>
              <div class="alert-content">
                <strong>How to use templates:</strong>
                <ul class="template-instructions">
                  <li>Select the appropriate template format for your needs</li>
                  <li>Download the template file</li>
                  <li>
                    Fill in your user data following the template structure
                  </li>
                  <li>Upload the completed file using the import section</li>
                </ul>
              </div>
            </v-alert>
          </div>

          <div class="template-table-wrapper">
            <v-data-table-server
              :items="dataTemplate"
              :headers="enhancedHeadersTemplate"
              loading-text="Loading..."
              hide-default-footer
              disable-sort
              class="template-table"
              density="comfortable"
            >
              <template v-slot:item="{ item }">
                <tr class="template-row">
                  <!-- CSV Column -->
                  <td class="download-cell">
                    <v-btn
                      id="button-downloadtemplate-csv-userchatmanagement"
                      variant="elevated"
                      color="success"
                      size="small"
                      class="download-btn"
                      @click="linkDownload(item.CSV)"
                    >
                      <v-icon start>mdi-file</v-icon>
                      CSV
                      <v-tooltip activator="parent" location="top">
                        Download User - CSV Template
                      </v-tooltip>
                    </v-btn>
                  </td>

                  <!-- Excel Column -->
                  <td class="download-cell">
                    <v-btn
                      id="button-downloadtemplate-excel-userchatmanagement"
                      variant="elevated"
                      color="green"
                      size="small"
                      class="download-btn"
                      @click="linkDownload(item.Excel)"
                    >
                      <v-icon start>mdi-file-excel</v-icon>
                      Excel
                      <v-tooltip activator="parent" location="top">
                        Download User - Excel Template
                      </v-tooltip>
                    </v-btn>
                  </td>
                </tr>
              </template>
            </v-data-table-server>
          </div>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions class="template-actions">
          <v-spacer></v-spacer>
          <v-btn
            variant="elevated"
            color="red"
            @click="flagTemplate = false"
            class="close-dialog-action-btn"
          >
            <v-icon start>mdi-close</v-icon>
            {{ $t("close") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!--dialog change password-->
    <v-dialog
      v-model="changPasswordDialog"
      max-width="600px"
      persistent
      class="modern-dialog"
    >
      <v-card class="dialog-card">
        <div class="dialog-header dialog-header-change-password">
          <div class="header-main">
            <div class="header-icon-container">
              <div class="icon-background icon-background-orange">
                <v-icon size="28" color="white">mdi-lock-reset</v-icon>
              </div>
            </div>
            <div class="header-text-content">
              <h2 class="dialog-title">Change Password</h2>
              <p class="dialog-subtitle">
                Create a new secure password for your account
              </p>
            </div>
          </div>
          <div class="header-actions">
            <v-btn
              icon
              variant="text"
              color="white"
              @click="closeChangePassword"
              class="close-button"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </div>
          <!-- <div class="header-content">
            <div class="header-left">
              <div class="header-icon icon-background">
                <v-icon size="28" color="white">mdi-lock-reset</v-icon>
              </div>
              <div class="header-text">
                <h2 class="dialog-title">Change Password</h2>
                <p class="dialog-subtitle">
                  Create a new secure password for your account
                </p>
              </div>
              
            </div>
            <div class="header-right">
                <v-btn
                  icon
                  variant="text"
                  size="small"
                  @click="closeChangePassword"
                  class="close-btn"
                >
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </div>
          </div> -->
        </div>

        <v-divider></v-divider>

        <v-card-text class="change-password-content">
          <v-container fluid>
            <!-- Password Section -->
            <div class="form-section">
              <div class="section-title">
                <v-icon color="primary" class="mr-2">mdi-lock-outline</v-icon>
                Password Requirements
              </div>

              <v-row class="form-row">
                <v-col cols="12" md="6">
                  <div class="input-wrapper">
                    <label class="input-label">New Password *</label>
                    <v-text-field
                      id="password-field-popupedit-userchatmanagement"
                      ref="password"
                      :label="$t('password')"
                      :rules="[rules.required]"
                      v-model="edit.password"
                      :type="show3 ? 'text' : 'password'"
                      variant="outlined"
                      density="compact"
                      hide-details="auto"
                      placeholder="Enter new password"
                      class="modern-input"
                    >
                      <template v-slot:append-inner>
                        <v-btn
                          @click="show3 = !show3"
                          icon
                          variant="text"
                          size="small"
                          class="password-toggle"
                        >
                          <v-icon size="18">{{
                            show3 ? "mdi-eye" : "mdi-eye-off"
                          }}</v-icon>
                        </v-btn>
                        <!-- <v-tooltip location="top">
                          <template v-slot:activator="{ props }">
                            <v-icon
                              size="18"
                              v-bind="props"
                              class="help-icon ml-2"
                            >
                              mdi-information-outline
                            </v-icon>
                          </template>
                          <span>{{ $t("password") }}</span>
                        </v-tooltip> -->
                      </template>
                    </v-text-field>

                    <!-- Password Requirements with Animation -->
                    <transition name="slide-fade" mode="out-in">
                      <div
                        class="password-requirements"
                        v-if="edit.password"
                        key="requirements"
                      >
                        <div
                          class="requirement-item"
                          :class="{ valid: checkLengthPassword }"
                        >
                          <v-icon
                            size="12"
                            :color="checkLengthPassword ? 'success' : 'error'"
                          >
                            {{
                              checkLengthPassword ? "mdi-check" : "mdi-close"
                            }}
                          </v-icon>
                          <span>{{ $t("checklengthcharacters") }}</span>
                        </div>
                        <div
                          class="requirement-item"
                          :class="{ valid: checkLowercaseLetter }"
                        >
                          <v-icon
                            size="12"
                            :color="checkLowercaseLetter ? 'success' : 'error'"
                          >
                            {{
                              checkLowercaseLetter ? "mdi-check" : "mdi-close"
                            }}
                          </v-icon>
                          <span>{{ $t("checklowercaseletter") }}</span>
                        </div>
                        <div
                          class="requirement-item"
                          :class="{ valid: checkUppercaseLetter }"
                        >
                          <v-icon
                            size="12"
                            :color="checkUppercaseLetter ? 'success' : 'error'"
                          >
                            {{
                              checkUppercaseLetter ? "mdi-check" : "mdi-close"
                            }}
                          </v-icon>
                          <span>{{ $t("checkuppercaseletter") }}</span>
                        </div>
                        <div
                          class="requirement-item"
                          :class="{ valid: checkNumber }"
                        >
                          <v-icon
                            size="12"
                            :color="checkNumber ? 'success' : 'error'"
                          >
                            {{ checkNumber ? "mdi-check" : "mdi-close" }}
                          </v-icon>
                          <span>{{ $t("checknumber") }}</span>
                        </div>
                        <div
                          class="requirement-item"
                          :class="{ valid: checkSpecialCharacter }"
                        >
                          <v-icon
                            size="12"
                            :color="checkSpecialCharacter ? 'success' : 'error'"
                          >
                            {{
                              checkSpecialCharacter ? "mdi-check" : "mdi-close"
                            }}
                          </v-icon>
                          <span>{{ $t("checkspecialcharacter") }}</span>
                        </div>
                      </div>
                    </transition>
                  </div>
                </v-col>
                <v-col cols="12" md="6">
                  <div class="input-wrapper">
                    <label class="input-label">Confirm New Password *</label>
                    <v-text-field
                      id="confirmpassword-field-popupedit-userchatmanagement"
                      ref="confirmpassword"
                      :label="$t('confirmpassword')"
                      :rules="[rules.required]"
                      v-model="edit.confirmpassword"
                      :type="show4 ? 'text' : 'password'"
                      variant="outlined"
                      density="compact"
                      hide-details="auto"
                      placeholder="Confirm new password"
                      class="modern-input"
                    >
                      <template v-slot:append-inner>
                        <v-btn
                          @click="show4 = !show4"
                          icon
                          variant="text"
                          size="small"
                          class="password-toggle"
                        >
                          <v-icon size="18">{{
                            show4 ?  "mdi-eye" : "mdi-eye-off"
                          }}</v-icon>
                        </v-btn>
                        <!-- <v-tooltip location="top">
                          <template v-slot:activator="{ props }">
                            <v-icon
                              size="18"
                              v-bind="props"
                              class="help-icon ml-2"
                            >
                              mdi-information-outline
                            </v-icon>
                          </template>
                          <span>{{ $t("confirmpassword") }}</span>
                        </v-tooltip> -->
                      </template>
                    </v-text-field>

                    <!-- Password Match Indicator with Animation -->
                    <transition name="slide-fade" mode="out-in">
                      <div
                        class="password-match"
                        v-if="edit.confirmpassword"
                        key="match"
                      >
                        <div
                          class="requirement-item"
                          :class="{ valid: checkPasswordMatch }"
                        >
                          <v-icon
                            size="12"
                            :color="checkPasswordMatch ? 'success' : 'error'"
                          >
                            {{ checkPasswordMatch ? "mdi-check" : "mdi-close" }}
                          </v-icon>
                          <span>{{ $t("checkpasswordmatch") }}</span>
                        </div>
                      </div>
                    </transition>
                  </div>
                </v-col>
              </v-row>

              <!-- Password Strength Indicator with Animation -->
              <transition name="expand-fade" mode="out-in">
                <v-row class="form-row" v-if="edit.password" key="strength">
                  <v-col cols="12">
                    <div class="password-strength-wrapper">
                      <div class="strength-label">
                        <v-icon
                          :color="passwordStrength.color"
                          :icon="passwordStrength.icon"
                          size="16"
                          class="mr-2"
                        >
                        </v-icon>
                        Password Strength:
                        <span
                          :style="{ color: passwordStrength.color }"
                          class="strength-text"
                        >
                          {{ passwordStrength.text }}
                        </span>
                      </div>
                      <v-progress-linear
                        :model-value="passwordStrength.value"
                        :color="passwordStrength.color"
                        height="6"
                        rounded
                        class="strength-bar"
                      >
                      </v-progress-linear>
                    </div>
                  </v-col>
                </v-row>
              </transition>
            </div>

            <!-- Security Tips -->
            <div class="security-tips">
              <v-alert
                type="info"
                variant="tonal"
                density="compact"
                class="security-alert"
              >
                <template v-slot:prepend>
                  <v-icon>mdi-shield-check-outline</v-icon>
                </template>
                <div class="alert-content">
                  <strong>Security Tips:</strong>
                  <ul class="tips-list">
                    <li>Use a unique password that you don't use elsewhere</li>
                    <li>
                      Consider using a passphrase with mixed case, numbers, and
                      symbols
                    </li>
                    <li>
                      Avoid personal information like names, birthdays, or
                      common words
                    </li>
                    <li>Change your password regularly for better security</li>
                  </ul>
                </div>
              </v-alert>
            </div>
          </v-container>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions class="change-password-actions">
          <v-spacer></v-spacer>
          <v-btn
            variant="outlined"
            color="grey"
            @click="closeChangePassword"
            class="dialog-action-btn cancel-btn"
          >
            <v-icon start>mdi-close</v-icon>
            {{ $t("close") }}
          </v-btn>
          <v-btn
            id="button-savechangepassword-popupedit-userchatmanagement"
            variant="elevated"
            @click="saveChangePassword"
            :disabled="!passwordIsValid"
            class="dialog-action-btn save-btn-change-password"
          >
            <v-icon start>mdi-content-save</v-icon>
            {{ $t("save") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import CryptoJS from "crypto-js";
import Cookies from "js-cookie";
import store from "../store";
import ExcelJS from "exceljs";

// import checkPermissionFour from "@/api/function.js";
import LogTrace from "@/api/function.js";
import { mask } from "vue-the-mask";
import DragDropFile from "@/components/DragDropFile.vue";
import LineIcon from "@/components/icons/LineIcon.vue";
export default {
  name: "UserChatManagement",
  inject: ["flagNav","FontColorTitle","SubNavbarBackGround"],
  components: { DragDropFile, LineIcon },
  mixins: [LogTrace],
  directives: {
    mask,
  },
  data() {
    return {
      mask: "##########",
      show1: false,
      show2: false,
      show3: false,
      show4: false,
      formHasErrors: false,
      flagShowSync: false,
      permission: {
        add: true,
        edit: true,
        delete: true,
      },
      mailcheck: false,
      phonecheck: false,
      filters: {
        username: [],
        email: [],
        employeeName: [],
        userType: [],
      },
      DDRole: [
        {
          name: "Admin",
          value: 1,
        },
        {
          name: "ผู้ใช้งานทั่วไป",
          value: 2,
        },
      ],
      numberRules: [(v) => !!v || "Input is required!"],
      rules: {
        required: (value) => value === null || !!value || "Required.",
        min: (v) => v.length >= 10 || "Min 10 numbers",
      },
      Email: null,
      gg: null,
      UserType: null,
      dialog: false,
      edit: {
        id: null,
        username: null,
        firstname: null,
        lastname: null,
        email: null,
        phone: null,
        password: null,
        confirmpassword: null,
        roleId: null,
        userType: null,
        groupModel: null,
        model: [],
        modelQuickGroupID: null,
        socialUserID: null,
        recipientId: null,
        recipientId_Instagram: null,
        isUserFromLine: null,
        lockStatus: false,
      },
      user: {
        id: null,
        username: null,
        firstname: null,
        lastname: null,
        email: null,
        phone: null,
        password: null,
        confirmpassword: null,
        roleId: null,
        userType: null,
        groupModel: null,
        model: [],
        modelQuickGroupID: null,
        socialUserID: null,
        recipientId: null,
        recipientId_Instagram: null,
        lockStatus: false,
      },
      // searchGroupModel: null,
      // searchModel: null,
      listDDGroupModel: [],
      listDDModel: [],

      oldPassword: "",
      Editdialog: false,
      Adddialog: false,
      isSearch: false,
      username: "",
      email: "",
      totalTable: 0,
      itemsPerPage: 10,
      options: {
        page: 1,
        itemsPerPage: 10,
        sortBy: [],
        sortDesc: [],
      },
      today: null,
      userListDDL: [],
      userList: [],
      headers: [],
      secretKey: "01234567890123456789012345678901",
      isFirst: true,
      searchTotalTable: 0,
      sortBy: [],
      sortDesc: [],
      DDQuickModel: [],
      accept:
        "text/csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      fileImportUser: null,
      flagTemplate: false,
      dataTemplate: [
        {
          CSV: "CSV",
          Excel: "Excel",
        },
      ],
      //tempUserWarning: {},

      checkLengthPassword: true,
      checkLowercaseLetter: true,
      checkUppercaseLetter: true,
      checkNumber: true,
      checkSpecialCharacter: true,
      checkPasswordMatch: true,
      statusFormatPassword: false,
      statusPassword: false,
      flagChangePassword: false,
      changPasswordDialog: false,
    };
  },
  watch: {
    options: {
      handler() {
        this.GetInformation();
      },
      deep: true,
      immediate: true,
    },
    // searchGroupModel(val) {
    //   this.GetGroupModel(val);
    // },
    // searchModel(val) {
    //   this.GetModel(val);
    // },
    "user.password"() {
      let self = this;
      if (
        self.user.password != null &&
        self.user.password != undefined &&
        self.user.password != ""
      ) {
        self.checkLengthPassword = self.user.password.length >= 8;
        self.checkLowercaseLetter = /[a-z]/.test(self.user.password);
        self.checkUppercaseLetter = /[A-Z]/.test(self.user.password);
        self.checkNumber = /\d/.test(self.user.password);
        // self.checkSpecialCharacter = /[!@#$%^&*(),.?":{}|<>]/.test(self.user.password);
        self.checkSpecialCharacter = /[^a-zA-Z0-9ก-๙]/.test(self.user.password);
        if (
          self.checkLengthPassword == true &&
          self.checkLowercaseLetter == true &&
          self.checkUppercaseLetter == true &&
          self.checkNumber == true &&
          self.checkSpecialCharacter == true
        ) {
          self.statusFormatPassword = true;
        } else {
          self.statusFormatPassword = false;
        }
        if (self.user.password == self.user.confirmpassword) {
          self.checkPasswordMatch = true;
        } else if (
          self.user.confirmpassword != null &&
          self.user.confirmpassword.length > 0
        ) {
          self.checkPasswordMatch = false;
        }
      }
    },
    "user.confirmpassword"() {
      let self = this;
      self.checkPasswordMatch = self.user.password == self.user.confirmpassword;
      if (
        self.user.password == self.user.confirmpassword &&
        self.checkLengthPassword == true &&
        self.checkLowercaseLetter == true &&
        self.checkUppercaseLetter == true &&
        self.checkNumber == true &&
        self.checkSpecialCharacter == true
      ) {
        self.statusPassword = true;
      } else {
        self.statusPassword = false;
      }
    },
    "edit.password"() {
      let self = this;
      if (
        self.edit.password != null &&
        self.edit.password != undefined &&
        self.edit.password != ""
      ) {
        self.checkLengthPassword = self.edit.password.length >= 8;
        self.checkLowercaseLetter = /[a-z]/.test(self.edit.password);
        self.checkUppercaseLetter = /[A-Z]/.test(self.edit.password);
        self.checkNumber = /\d/.test(self.edit.password);
        // self.checkSpecialCharacter = /[!@#$%^&*(),.?":{}|<>]/.test(self.edit.password);
        self.checkSpecialCharacter = /[^a-zA-Z0-9ก-๙]/.test(self.edit.password);
        if (
          self.checkLengthPassword == true &&
          self.checkLowercaseLetter == true &&
          self.checkUppercaseLetter == true &&
          self.checkNumber == true &&
          self.checkSpecialCharacter == true
        ) {
          self.statusFormatPassword = true;
        } else {
          self.statusFormatPassword = false;
        }
        if (self.edit.password == self.edit.confirmpassword) {
          self.checkPasswordMatch = true;
        } else if (
          self.edit.confirmpassword != null &&
          self.edit.confirmpassword != null &&
          self.edit.confirmpassword.length > 0
        ) {
          self.checkPasswordMatch = false;
        }
      }
    },
    "edit.confirmpassword"() {
      let self = this;
      self.checkPasswordMatch = self.edit.password == self.edit.confirmpassword;
      if (
        self.edit.password == self.edit.confirmpassword &&
        self.checkLengthPassword == true &&
        self.checkLowercaseLetter == true &&
        self.checkUppercaseLetter == true &&
        self.checkNumber == true &&
        self.checkSpecialCharacter == true
      ) {
        self.statusPassword = true;
      } else {
        self.statusPassword = false;
      }
    },
  },
  mounted() {
    // this.permission = this.checkPermissionFour(1, 2, 3, 4);
    this.headers = [
      {
        title: this.$t("no"),
        align: "center",
        sortable: false,
      },
      {
        title: this.$t("username"),
        align: "center",
        sortable: true,
        value: "username",
      },
      {
        title: this.$t("email"),
        align: "center",
        sortable: true,
        value: "email",
      },
      {
        title: this.$t("phonenumber"),
        align: "center",
        sortable: true,
        value: "mobile",
      },
      { title: "Name", align: "center", sortable: true, value: "fullName" },
      {
        title: this.$t("action"),
        align: "center",
        sortable: false,
        width: "150px",
      },
    ];
    this.GetDate();
    this.GetGroupModel();
    this.GetModel();
    this.GetDDModelQuickGroup();
  },
  computed: {
    passwordStrength() {
      if (!this.edit.password)
        return {
          value: 0,
          color: "grey",
          text: "No password",
          icon: "mdi-minus",
        };

      let score = 0;
      let feedback = [];

      // Length check
      if (this.edit.password.length >= 8) score += 20;
      else feedback.push("Use at least 8 characters");

      // Character variety checks
      if (/[a-z]/.test(this.edit.password)) score += 15;
      else feedback.push("Add lowercase letters");

      if (/[A-Z]/.test(this.edit.password)) score += 15;
      else feedback.push("Add uppercase letters");

      if (/\d/.test(this.edit.password)) score += 15;
      else feedback.push("Add numbers");

      if (/[^a-zA-Z0-9ก-๙]/.test(this.edit.password)) score += 15;
      else feedback.push("Add special characters");

      // Additional complexity
      if (this.edit.password.length >= 12) score += 10;
      if (this.edit.password.length >= 16) score += 10;

      if (score <= 30) {
        return {
          value: score,
          color: "error",
          text: "Weak",
          icon: "mdi-shield-alert",
        };
      } else if (score <= 60) {
        return {
          value: score,
          color: "warning",
          text: "Fair",
          icon: "mdi-shield-half-full",
        };
      } else if (score <= 80) {
        return {
          value: score,
          color: "info",
          text: "Good",
          icon: "mdi-shield-check",
        };
      } else {
        return {
          value: score,
          color: "success",
          text: "Strong",
          icon: "mdi-shield-check-outline",
        };
      }
    },

    passwordIsValid() {
      return (
        this.checkLengthPassword &&
        this.checkLowercaseLetter &&
        this.checkUppercaseLetter &&
        this.checkNumber &&
        this.checkSpecialCharacter &&
        this.checkPasswordMatch &&
        this.edit.password &&
        this.edit.confirmpassword
      );
    },
    enhancedHeadersTemplate() {
      return [
        {
          title: "CSV",
          key: "csv",
          align: "center",
          width: "50%",
          sortable: false,
        },
        {
          title: "Excel",
          key: "excel",
          align: "center",
          width: "50%",
          sortable: false,
        },
      ];
    },
    filteredUsers() {
      return this.userList.filter((d) => {
        return Object.keys(this.filters).every((f) => {
          return this.filters[f].length < 1 || this.filters[f].includes(d[f]);
        });
      });
    },
    form() {
      return {
        username: this.user.username,
        firstname: this.user.firstname,
        lastname: this.user.lastname,
        email: this.user.email,
        phone: this.user.phone,
        password: this.user.password,
        confirmpassword: this.user.confirmpassword,
        groupModel: this.user.groupModel,
        model: this.user.model,
        modelQuickGroupID: this.user.modelQuickGroupID,
        socialUserID: this.user.socialUserID,
        recipientId: this.user.recipientId,
        recipientId_Instagram: this.user.recipientId_Instagram,
      };
    },
    headersTemplate() {
      return [
        { text: "CSV", align: "center" },
        { text: "Excel", align: "center" },
      ];
    },
    emailRules() {
      if (this.edit.isUserFromLine) {
        return [];
      } else {
        return [this.rules.required, this.validateEmail(this.edit.email)];
      }
    },
  },

  methods: {
    triggerFileUpload() {
      // เลือกวิธีใดวิธีหนึ่ง:

      // วิธีที่ 1: ถ้า DragDropFile มี method openFileDialog ที่ expose ออกมา
      if (
        this.$refs.fileUploader &&
        typeof this.$refs.fileUploader.openFileDialog === "function"
      ) {
        this.$refs.fileUploader.openFileDialog();
      }
      // วิธีที่ 2: เข้าถึง input file ภายใน DragDropFile โดยตรง (ถ้าเป็นไปได้)
      else if (this.$refs.fileUploader && this.$refs.fileUploader.$el) {
        const fileInput =
          this.$refs.fileUploader.$el.querySelector('input[type="file"]');
        if (fileInput) {
          fileInput.click();
        }
      }
    },
    async SyncUser() {
      let self = this;
      self.dialog = true;
      await self.$call.SyncUserChat(
        null,
        (dataResponse) => {
          if (dataResponse.status == 0) {
            self.$swal.fire({
              icon: "success",
              title: dataResponse.data.message,
              showConfirmButton: false,
              timer: 1500,
            });
          } else {
            self.$swal.fire({
              icon: "warning",
              title: self.$t("_SSOWarning"),
              showConfirmButton: false,
              timer: 1800,
            });
          }
          self.dialog = false;
          self.GetInformationDefault();
        },
        (errorResource) => {
          console.error(errorResource);
          self.dialog = false;
        }
      );
    },
    processUpload(e) {
      let self = this;
      if (e.length > 0) {
        self.fileImportUser = e[0];
        const fileType = self.fileImportUser.name
          .split(".")
          .pop()
          .toLowerCase();

        if (fileType === "xlsx" || fileType === "xls") {
          // Handle Excel files
          const reader = new FileReader();
          reader.onload = async (event) => {
            try {
              const workbook = new ExcelJS.Workbook();
              await workbook.xlsx.load(event.target.result);

              // ใช้ worksheet แรก
              const worksheet = workbook.worksheets[0];
              const jsonData = [];

              // อ่านข้อมูลจาก headers
              const headers = [];
              worksheet.getRow(1).eachCell((cell, colNumber) => {
                headers[colNumber - 1] = cell.value;
              });

              // แปลงข้อมูลเป็น JSON
              worksheet.eachRow((row, rowNumber) => {
                if (rowNumber !== 1) {
                  // ข้ามแถวแรกที่เป็นหัวข้อ
                  const rowData = {};
                  row.eachCell((cell, colNumber) => {
                    rowData[headers[colNumber - 1]] = cell.value;
                  });
                  jsonData.push(rowData);
                }
              });
              self.validateData(jsonData);
            } catch (error) {
              console.error("Error processing Excel file:", error);
              self.$swal.fire({
                icon: "error",
                title: "Error",
                text: `Failed to process Excel file.\n${error.message}`,
              });
            }
          };
          reader.readAsArrayBuffer(self.fileImportUser);
        } else if (fileType === "csv") {
          const reader = new FileReader();
          reader.onload = (event) => {
            const text = event.target.result;

            const rows = text.split("\n").map((row) => row.split(","));
            const headers = rows[0].map((header) => header.trim());
            const jsonData = rows
              .slice(1)
              .map((row) => {
                const obj = {};
                row.forEach((cell, index) => {
                  obj[headers[index]] = cell.trim();
                });
                return obj;
              })
              .filter((row) => Object.keys(row).length > 0);

            self.validateData(jsonData);
          };
          reader.readAsText(self.fileImportUser);
        } else {
          self.$swal.fire({
            icon: "warning",
            title: "Invalid file type",
            text: "Please upload an Excel (.xlsx) or CSV (.csv) file.",
          });
        }
      }
    },
    validateData(data) {
      let self = this;
      const requiredColumns = ["User Name", "Email"];
      const missingColumns = requiredColumns.filter(
        (col) => !Object.keys(data[0] || {}).includes(col)
      );
      if (missingColumns.length > 0) {
        // alert(`Missing columns: ${missingColumns.join(", ")}`);
        self.$swal.fire({
          icon: "warning",
          title: "Missing Columns",
          text: `The following required columns are missing: ${missingColumns.join(", ")}`,
        });
        return;
      }
      const usernames = data
        .map((row) => (typeof row["User Name"] === "string" ? row["User Name"] : String(row["User Name"] ?? "")).trim())
        .filter(Boolean);
      const emails = data
        .map((row) => (typeof row["Email"] === "string" ? row["Email"] : String(row["Email"] ?? "")).trim())
        .filter(Boolean);

      const duplicateUsernames = usernames.filter(
        (value, index, self) => self.indexOf(value) !== index
      );
      const duplicateEmails = emails.filter(
        (value, index, self) => self.indexOf(value) !== index
      );

      if (duplicateUsernames.length > 0 || duplicateEmails.length > 0) {
        let errorMessage = "";
        if (duplicateUsernames.length > 0) {
          errorMessage += `Duplicate usernames</br> - ${[
            ...new Set(duplicateUsernames),
          ].join(", ")}</br>`;
        }
        if (duplicateEmails.length > 0) {
          errorMessage += `Duplicate emails</br> - ${[
            ...new Set(duplicateEmails),
          ].join(", ")}</br>`;
        }
        self.$swal.fire({
          icon: "warning",
          title: self.$t("warning"),
          html: `${errorMessage}`,
          confirmButtonColor: "#3085d6",
          confirmButtonText: "Close",
        });
      } else {
        self.ConfirmProcess();
      }
    },

    ConfirmProcess() {
      let self = this;
      self.$swal
        .fire({
          icon: "warning",
          title: this.$t("importUserTitle"),
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: this.$t("yes"),
          cancelButtonText: this.$t("cancel"),
        })
        .then((result) => {
          if (result.isConfirmed) {
            self.ImportUser();
          }
        });
    },

    async ImportUser() {
      let self = this;
      self.dialog = true;
      const formDataDoc = new FormData();
      formDataDoc.append("entity", self.fileImportUser);

      var requestUser = {
        entity: formDataDoc,
        isUserChat: true,
      };

      await self.$call.ImportUser(
        requestUser,
        null,
        async (dataResponse) => {
          if (dataResponse.status == 0) {
            if (
              dataResponse.data.mesDupUser.length > 0 ||
              dataResponse.data.mesDupEmail.length > 0 ||
              dataResponse.data.mesEmailNotFormat.length > 0 ||
              //FillAll.length > 0 ||
              dataResponse.data.mesModelNotFormat.length > 0 ||
              dataResponse.data.mesDupSocialUserID.length > 0
            ) {
              let DupUser = dataResponse.data.mesDupUser;
              let DupEmail = dataResponse.data.mesDupEmail;
              let EmailNotFormat = dataResponse.data.mesEmailNotFormat;
              let mesModelNotFormat = dataResponse.data.mesModelNotFormat;
              let DupSocialUserID = dataResponse.data.mesDupSocialUserID;
              var htmlString = "";

              const countDupUser = DupUser.length;
              const countDupEmail = DupEmail.length;
              const countEmailNotFormat = EmailNotFormat.length;
              //const countFillAll = FillAll.length;
              const countModelNotFormat = mesModelNotFormat.length;
              const countDupSocialUserID = DupSocialUserID.length;

              for (let i = 0; i < countDupUser; i++) {
                if (i == 0) {
                  htmlString += "duplicate username</br>";
                }
                htmlString += " -" + DupUser[i] + "</br>";
              }
              for (let i = 0; i < countDupEmail; i++) {
                if (i == 0) {
                  htmlString += "duplicate email</br>";
                }
                htmlString += " -" + DupEmail[i] + "</br>";
              }
              for (let i = 0; i < countEmailNotFormat; i++) {
                if (i == 0) {
                  htmlString += "Email is not formatted correctly</br>";
                }
                htmlString += " -" + EmailNotFormat[i] + "</br>";
              }
              // for (let i = 0; i < countFillAll; i++) {
              //   if (i == 0) {
              //     htmlString += "Please fill the required fields</br>";
              //   }
              //   htmlString += " -" + FillAll[i] + "</br>";
              // }
              for (let i = 0; i < countModelNotFormat; i++) {
                if (i == 0) {
                  htmlString += "Model is not formatted correctly</br>";
                }
                htmlString += " -" + mesModelNotFormat[i] + "</br>";
              }
              for (let i = 0; i < countDupSocialUserID; i++) {
                if (i == 0) {
                  htmlString += "duplicate Social UserID</br>";
                }
                htmlString += " -" + DupSocialUserID[i] + "</br>";
              }

              // htmlString += `<a href="${link}">Download User Warning File</a>`;
              // htmlString += `<a @click="CreateCSVUserWarning1()">Download User Warning File</a>`;

              self.$swal.fire({
                icon: "warning",
                title: "Warning!",
                html: `${htmlString}`,
                confirmButtonColor: "#3085d6",
                confirmButtonText: "Close",
              });
            } else {
              self.$swal.fire({
                icon: "success",
                title: dataResponse.message,
                showConfirmButton: false,
                timer: 1500,
              });
              self.GetInformation();
            }
          } else {
            self.$swal.fire({
              icon: "warning",
              title: "Warning!",
              html: dataResponse.message,
              confirmButtonColor: "#3085d6",
              confirmButtonText: "Close",
            });
          }
          self.options.page = 1;
          self.GetInformationDefault();
          self.dialog = false;
        },
        (errorResource) => {
          self.dialog = false;
          console.error(errorResource);
        }
      );
    },

    // async CreateCSVUserWarning(DupUser, DupEmail, EmailNotFormat, FillAll, countMax) {
    //   let self = this;
    //   let array = [['\ufeffDuplicate username', '\ufeffDuplicate email', '\ufeffEmail is not formatted correctly', '\ufeffPlease fill the required fields']];
    //   for (let i = 0; i < countMax; i++) {
    //     array.push([DupUser[i], DupEmail[i], EmailNotFormat[i], FillAll[i]]);
    //   }
    //   await self.CreateCSVFileDownload(array);
    // },

    // async CreateCSVFileDownload(array) {
    //   let str = '';
    //   for (const item of array) {
    //     let line = '';
    //     line = item.join(',');
    //     str += line + '\r\n';
    //   }
    //   let blob = new Blob([str], { type: 'text/csv;charset=utf-8;' });
    //   let link = document.createElement('a');
    //   let url = URL.createObjectURL(blob);
    //   link.setAttribute('href', url);
    //   link.setAttribute('download', `UserWarning.csv`);
    //   link.style.visibility = 'hidden';
    //   document.body.appendChild(link);
    //   link.click();
    //   document.body.removeChild(link);
    // },

    linkDownload(modelType) {
      let self = this;

      if (modelType === "Excel") {
        // สร้าง Excel ด้วย ExcelJS
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet("Template");

        // กำหนดคอลัมน์
        worksheet.columns = [
          { header: "User Name", key: "username", width: 20 },
          { header: "Password", key: "password", width: 20 },
          { header: "First Name", key: "firstName", width: 20 },
          { header: "Last Name", key: "lastName", width: 20 },
          { header: "Email", key: "email", width: 25 },
          { header: "Phone Number", key: "phoneNumber", width: 15 },
          { header: "Social User ID", key: "socialUserID", width: 25 },
          { header: "Recipient ID (Facebook)", key: "recipientId", width: 25 },
          {
            header: "Recipient ID (Instagram)",
            key: "recipientId_Instagram",
            width: 25,
          },
          { header: "Model", key: "model", width: 20 },
        ];

        // ปรับแต่งสไตล์หัวคอลัมน์
        worksheet.getRow(1).font = { bold: true };
        worksheet.getRow(1).fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "FFE0E0E0" },
        };

        // ขนาดคอลัมน์อัตโนมัติ
        worksheet.columns.forEach((column) => {
          column.width = column.width || 15;
        });

        // ดาวน์โหลดไฟล์
        workbook.xlsx.writeBuffer().then((buffer) => {
          const blob = new Blob([buffer], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          const url = URL.createObjectURL(blob);
          const a = document.createElement("a");
          a.href = url;
          a.download = `Template_UserChat_${modelType}.xlsx`;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          URL.revokeObjectURL(url);
        });

        self.flagTemplate = false;
      } else if (modelType === "CSV") {
        // สำหรับ CSV ยังใช้วิธีเดิม
        let req = {
          modelType: modelType,
          filename: "UserChat",
        };
        self.$call.DownloadTemplateUser(
          req,
          (dataResponse) => {
            if (dataResponse) {
              let fileURL = window.URL.createObjectURL(
                new Blob([dataResponse])
              );
              let fileLink = document.createElement("a");

              fileLink.href = fileURL;

              let fileNameshow = `Template_UserChat_${modelType}${self.findTypeName(
                modelType
              )}`;
              fileLink.setAttribute("download", fileNameshow);
              document.body.appendChild(fileLink);

              fileLink.click();
            }
            self.flagTemplate = false;
          },
          (errorResource) => {
            self.flagTemplate = false;
            console.error(errorResource);
          }
        );
      }
    },

    findTypeName(modelType) {
      let type = "";
      switch (modelType) {
        case "CSV":
          type = ".csv";
          break;
        case "Excel":
          type = ".xlsx";
          break;
        case "ExcelMultiColumn":
          type = ".xlsx";
          break;
        case "PDF":
          type = ".pdf";
          break;
        case "Word":
          type = ".docx";
          break;
        case "Text":
          type = ".txt";
          break;
        case "PowerPoint":
          type = ".pptx";
          break;
      }
      return type;
    },

    // GetModel(val) {
    //   console.log("GetModel", val);
    //   let self = this;
    //   let temp = {
    //     page: 1,
    //     perPage: 5,
    //     modelName: val,
    //   };
    //   self.$call.GetTableGPTModel(
    //     temp,
    //     (dataResponse) => {
    //       if (dataResponse.status == 0) {
    //         self.listDDModel = dataResponse.data.data;
    //       } else {
    //         self.listDDModel = [];
    //       }
    //     },
    //     (errorResource) => {
    //       console.error(errorResource);
    //     }
    //   );
    // },
    // GetGroupModel(val) {
    //   let self = this;
    //   let temp = {
    //     page: 1,
    //     perPage: 5,
    //     name: val,
    //   };
    //   self.$call.GetTableGroupModel(
    //     temp,
    //     (dataResponse) => {
    //       if (dataResponse.status == 0) {
    //         self.listDDGroupModel = dataResponse.data.data;
    //       } else {
    //         self.listDDGroupModel = [];
    //       }
    //     },
    //     (errorResource) => {
    //       console.error(errorResource);
    //     }
    //   );
    // },
    GetModel() {
      let self = this;
      self.$call.DDGPTModel_IsPublishByUser(
        (dataResponse) => {
          if (dataResponse.status == 0) {
            self.listDDModel = dataResponse.data;
          } else {
            self.listDDModel = [];
          }
        },
        (errorResource) => {
          console.error(errorResource);
        }
      );
    },
    GetGroupModel() {
      let self = this;
      self.$call.GetDDGroupModel(
        (dataResponse) => {
          if (dataResponse.status == 0) {
            self.listDDGroupModel = dataResponse.data;
          } else {
            self.listDDGroupModel = [];
          }
        },
        (errorResource) => {
          console.error(errorResource);
        }
      );
    },
    PhoneNumberValidation(phno) {
      let phoneno = /^\d{10}$/;
      return phoneno.test(phno) || "Invalid Phone format";
    },

    validateEmail(email) {
      // eslint-disable-next-line no-useless-escape
      let re =
        /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

      return re.test(email) || "invalid email";
    },
    Search() {
      let self = this;
      self.isSearch = true;
      self.options.page = 1;
      self.GetInformationDefault();
    },
    GetDate() {
      let today1 = new Date();
      let dd = today1.getDate();
      let mm = today1.getMonth() + 1; //January is 0!

      let yyyy = today1.getFullYear();
      if (dd < 10) {
        dd = "0" + dd;
      }
      if (mm < 10) {
        mm = "0" + mm;
      }

      this.today = dd + "/" + mm + "/" + yyyy;
    },
    GetInformation() {
      try {
        let self = this;
        self.loadingTable = true;

        let { page, itemsPerPage, sortBy } = self.options;
        let sortField = null;
        let sortOrder = null;

        if (sortBy && sortBy.length > 0) {
          sortField = sortBy[0].key;
          sortOrder = sortBy[0].order === "desc";
        }

        let temp = {
          page: self.isSearch ? 1 : page,
          perPage: itemsPerPage != -1 ? itemsPerPage : self.totalTable,
          username: self.username,
          eMail: self.email,
          isUserChat: true,
          sortDesc: sortOrder,
          sortBy: sortField,
        };
        self.$call.GetTableUserChatManagement(
          temp,
          (dataResponse) => {
            if (dataResponse.status == 0) {
              self.flagShowSync = dataResponse.data.flag;
              self.searchTotalTable = dataResponse.data.total;
              self.userList = dataResponse.data.data;
              self.userListDDL = dataResponse.data.data;
              self.totalTable = self.isFirst
                ? dataResponse.data.total
                : self.totalTable;
            } else {
              self.flagShowSync = false;
              self.userList = [];
              self.totalTable = 0;
              self.searchTotalTable = 0;
            }
            self.loadingTable = false;
            self.isSearch = false;
            self.isFirst = false;
          },
          (errorResource) => {
            self.loadingTable = false;
            self.isSearch = false;
            console.error(errorResource);
          }
        );
      } catch (error) {
        this.LogTrace(error, "Get");
      }
    },
    GetInformationDefault() {
      try {
        let self = this;
        self.dialog = true;
        const { page, itemsPerPage } = this.options;
        let temp = {
          page: self.isSearch ? 1 : page,
          perPage: itemsPerPage != -1 ? itemsPerPage : self.totalTable,
          username: self.username,
          eMail: self.email,
          isUserChat: true,
          sortDesc: null,
          sortBy: null,
        };
        self.$call.GetTableUserChatManagement(
          temp,
          (dataResponse) => {
            if (dataResponse.status == 0) {
              self.searchTotalTable = dataResponse.data.total;
              self.userList = dataResponse.data.data;
              self.userListDDL = dataResponse.data.data;
              self.totalTable = self.isFirst
                ? dataResponse.data.total
                : self.totalTable;
            } else {
              self.userList = [];
              self.totalTable = 0;
              self.searchTotalTable = 0;
            }
            self.dialog = false;
            self.isSearch = false;
            self.isFirst = false;
          },
          (errorResource) => {
            self.dialog = false;
            self.isSearch = false;
            console.error(errorResource);
          }
        );
      } catch (error) {
        this.LogTrace(error, "Get");
      }
    },
    EditUser(temp) {
      let self = this;
      self.Editdialog = true;
      // self.oldPassword = self.decryptShiftData(temp.password, 7);
      self.edit.id = temp.userId;
      self.edit.username = temp.username;
      self.edit.firstname = temp.firstName;
      self.edit.lastname = temp.lastName;
      // self.edit.password = temp.password;
      // self.edit.password = self.decryptShiftData(temp.password, 7);
      // self.edit.employeename = temp.employeeName;
      self.edit.roleId =
        temp.roleId == null || temp.roleId == undefined ? 2 : temp.roleId;
      self.edit.userType = temp.userType;
      self.edit.email = temp.email;
      self.edit.phone = temp.mobile;
      self.edit.modelQuickGroupID = temp.modelQuickGroupID;
      self.edit.socialUserID = temp.socialUserID;
      self.edit.recipientId = temp.recipientId;
      self.edit.recipientId_Instagram = temp.recipientId_Instagram;
      self.edit.isUserFromLine = temp.isUserFromLine;
      self.edit.lockStatus = temp.isLock;
      self.edit.confirmpassword = null;
      self.edit.password = null;
      self.flagChangePassword = false;
      self.checkLengthPassword = true;
      self.checkLowercaseLetter = true;
      self.checkUppercaseLetter = true;
      self.checkNumber = true;
      self.checkSpecialCharacter = true;
      self.checkPasswordMatch = true;
      if (temp.groupModel == null) {
        self.edit.groupModel = null;
        // self.listDDGroupModel = [];
      } else {
        self.edit.groupModel = parseInt(temp.groupModel);
        // self.listDDGroupModel = temp.groupModelList;
      }
      if (temp.model == null) {
        self.edit.model = [];
        // self.listDDModel = [];
      } else {
        self.edit.model = temp.model;
        // self.listDDModel = temp.modelList;
      }
    },
    UpdateUser() {
      try {
        let self = this;
        self.dialog = true;
        let emailvali = self.validateEmail(self.edit.email);
        // let phonevali = self.PhoneNumberValidation(self.edit.phone);
        if (
          self.edit.username != "" &&
          self.edit.lastname != "" &&
          self.edit.firstname != "" &&
          self.edit.email != "" &&
          // self.edit.phone != '' &&
          // ((self.edit.password != '' && self.flagChangePassword == false) ||
          //  (self.edit.password != '' && self.edit.confirmpassword != '' && self.flagChangePassword == true &&
          //   self.statusPassword == true && self.statusFormatPassword == true)) &&
          // self.statusPassword == true &&
          // self.statusFormatPassword == true &&
          ((self.edit.password != "" && self.flagChangePassword == false) ||
            (self.edit.password != "" &&
              self.edit.confirmpassword != "" &&
              self.flagChangePassword == true &&
              self.statusPassword == true &&
              self.statusFormatPassword == true)) &&
          // self.edit.roleId != null &&
          // self.edit.userType != "" &&
          (self.edit.groupModel != null || self.edit.model.length != 0) &&
          emailvali /*&&
          phonevali*/
        ) {
          let tempUser = {
            userId: self.edit.id,
            username: self.edit.username,
            password: self.flagChangePassword ? self.edit.password : "",
            idcard: 0,
            prefixId: 0,
            firstName: self.edit.firstname,
            lastName: self.edit.lastname,
            // roleId: 1,
            roleId: self.edit.roleId,
            // userType: self.edit.userType,
            mobile: self.edit.phone,
            eMail: self.edit.email,
            groupModel: self.edit.groupModel,
            model: self.edit.model,
            modelQuickGroupID: self.edit.modelQuickGroupID,
            socialUserID: self.edit.socialUserID,
            recipientId: self.edit.recipientId,
            recipientId_Instagram: self.edit.recipientId_Instagram,
            lockStatus: self.edit.lockStatus,
            isUserChat: true,
          };
          self.$call.UpdateUserChat(
            tempUser,
            (dataResponse) => {
              if (dataResponse.status == 0) {
                if (Cookies.get("userId") == self.edit.id) {
                  Cookies.set(
                    "fullName",
                    `${self.edit.firstname} ${self.edit.lastname}`
                  );
                  store.state.fullName = `${self.edit.firstname} ${self.edit.lastname}`;
                  Cookies.set("username", self.edit.username);
                  if (self.oldPassword != self.edit.password) {
                    self.$call.ClearUserInfo();
                    self.$router.push("/login");
                  }
                }
                self.$swal.fire({
                  icon: "success",
                  title: dataResponse.message,
                  showConfirmButton: false,
                  timer: 1500,
                });
                self.Editdialog = false;
                self.edit.name = null;
                self.edit.surname = null;
                self.edit.email = null;
                self.edit.department = null;
                self.edit.section = null;
                self.edit.status = null;
                self.edit.roleId = null;
                self.edit.userType = null;
                self.edit.model = null;
                self.edit.groupModel = null;
                self.edit.modelQuickGroupID = null;
                self.edit.socialUserID = null;
                self.edit.recipientId = null;
                self.edit.recipientId_Instagram = null;
                self.edit.lockStatus = false;
                self.GetInformation();
              } else {
                self.$swal.fire({
                  icon: "warning",
                  title: dataResponse.data.message,
                  showConfirmButton: false,
                  timer: 1800,
                });
              }
              self.dialog = false;
            },
            (errorResource) => {
              self.dialog = false;
              console.error(errorResource);
            }
          );
        } else {
          if (emailvali != true /*|| phonevali != true*/) {
            // alert("please fill correct format");
            self.$swal.fire({
              icon: "warning",
              title: "please fill correct format",
              confirmButtonColor: "#3085d6",
              confirmButtonText: "Close",
            });
          } else if (
            self.edit.username == "" ||
            self.edit.firstname == "" ||
            self.edit.lastname == "" ||
            self.edit.roleId == "" ||
            self.edit.userType == "" ||
            self.edit.groupModel == null ||
            self.edit.model.length < 1 ||
            self.edit.confirmpassword == "" ||
            self.edit.password == null ||
            self.edit.confirmpassword == null
          ) {
            self.$swal.fire({
              icon: "warning",
              title: "please fill all fields!!!",
              showConfirmButton: false,
              timer: 2000,
            });
          } else if (self.user.roleId == null) {
            self.$swal.fire({
              icon: "warning",
              title: "please fill correct format!",
              showConfirmButton: false,
              timer: 2000,
            });
          }
          self.formHasErrors = true;
          self.Editdialog = true;
          self.dialog = false;
        }
      } catch (error) {
        this.LogTrace(error, "UpdateUser");
      }
    },
    DeleteUser(id) {
      let self = this;
      try {
        self.$swal
          .fire({
            title: this.$t("confirmDeletion"),
            text: this.$t("confirmDeletionUser"),
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: this.$t("confirm"),
            cancelButtonText: this.$t("cancel"),
            reverseButtons: false,
          })
          .then((result) => {
            if (result.isConfirmed) {
              self.dialog = true;
              self.$call.DeleteUserChat(
                id,
                (dataResponse) => {
                  if (dataResponse.status == 0) {
                    self.totalTable = self.totalTable - 1;
                    self.GetInformation();
                    self.$swal.fire({
                      icon: "success",
                      title: dataResponse.message,
                      showConfirmButton: false,
                      timer: 1500,
                    });
                  }
                  self.dialog = false;
                },
                (errorResource) => {
                  self.dialog = false;
                  console.error(errorResource);
                }
              );
            }
          });
      } catch (error) {
        this.LogTrace(error, "DeleteUser");
      }
    },
    closeadd() {
      let self = this;

      Object.keys(self.form).forEach((f) => {
        self.$refs[f].reset();
      });

      self.Adddialog = false;
      self.user.model = null;
      self.user.groupModel = null;
      self.user.modelQuickGroupID = null;
      self.checkLengthPassword = true;
      self.checkLowercaseLetter = true;
      self.checkUppercaseLetter = true;
      self.checkNumber = true;
      self.checkSpecialCharacter = true;
      self.checkPasswordMatch = true;
      self.show1 = false;
      self.show2 = false;
    },
    AddUser() {
      try {
        let self = this;
        self.dialog = true;
        let emailvali = self.validateEmail(self.user.email);
        // let phonevali = self.PhoneNumberValidation(self.user.phone);
        if (
          self.user.username != null &&
          self.user.lastname != null &&
          self.user.firstname != null &&
          self.user.email != null &&
          // self.user.phone != null &&
          self.user.password != null &&
          self.user.confirmpassword != null &&
          self.statusPassword == true &&
          self.statusFormatPassword == true &&
          // self.user.roleId != null &&
          // self.user.userType != null &&
          (self.user.groupModel != null || self.user.model.length != 0) &&
          emailvali == true /*&&
          phonevali == true*/
        ) {
          let tempUser = {
            username: self.user.username,
            password: self.user.password,
            idCard: 0,
            prefixId: 0,
            firstName: self.user.firstname,
            lastName: self.user.lastname,
            // roleId: 1,
            roleId: self.user.roleId,
            // userType: self.user.userType,
            mobile: self.user.phone,
            eMail: self.user.email,
            groupModel: self.user.groupModel,
            model: self.user.model,
            modelQuickGroupID: self.user.modelQuickGroupID,
            socialUserID: self.user.socialUserID,
            recipientId: self.user.recipientId,
            recipientId_Instagram: self.user.recipientId_Instagram,
            isUserChat: true,
            lockStatus: self.user.lockStatus,
          };

          self.$call.CreateUserChat(
            tempUser,
            (dataResponse) => {
              if (dataResponse.status == 0) {
                self.$swal.fire({
                  icon: "success",
                  title: dataResponse.message,
                  showConfirmButton: false,
                  timer: 1500,
                });
                self.Adddialog = false;
                self.user.firstname = null;
                self.user.lastname = null;
                self.user.username = null;
                self.user.email = null;
                self.user.phone = null;
                self.user.model = null;
                self.user.groupModel = null;
                self.user.modelQuickGroupID = null;
                self.user.password = null;
                self.user.confirmpassword = null;
                self.user.socialUserID = null;
                self.user.recipientId = null;
                self.user.recipientId_Instagram = null;
                self.checkLengthPassword = true;
                self.checkLowercaseLetter = true;
                self.checkUppercaseLetter = true;
                self.checkNumber = true;
                self.checkSpecialCharacter = true;
                self.checkPasswordMatch = true;
                self.show1 = false;
                self.show2 = false;
                self.dialog = false;
                self.totalTable = self.totalTable + 1;
                self.GetInformation();
              } else {
                self.$swal.fire({
                  icon: "warning",
                  title: dataResponse.data.message,
                  showConfirmButton: false,
                  timer: 1800,
                });
              }
              self.dialog = false;
            },
            (errorResource) => {
              self.dialog = false;
              console.error(errorResource);
            }
          );
        } else {
          if (
            self.user.username == null &&
            self.user.firstname == null &&
            self.user.lastname == null &&
            self.user.password == null &&
            self.user.confirmpassword == null &&
            self.user.roleId == null &&
            self.user.userType == null &&
            emailvali != true /*&&
            phonevali != true*/
          ) {
            self.$swal.fire({
              icon: "warning",
              title: self.$t("warning"),
              text: self.$t("Please fill all the fields!!!"),
              showConfirmButton: false,
              timer: 2000,
            });
          } else if (
            self.user.username == null ||
            self.user.firstname == null ||
            self.user.lastname == null ||
            (self.user.groupModel == null && self.user.model.length < 1)
          ) {
            self.$swal.fire({
              icon: "warning",
              title: self.$t("warning"),
              text: self.$t("Please fill all the fields!!!"),
              showConfirmButton: false,
              timer: 2000,
            });
          } else if (emailvali != true /*|| phonevali != true*/) {
            self.$swal.fire({
              icon: "warning",
              title: self.$t("warning"),
              text: self.$t("Please fill correct format!"),
              showConfirmButton: false,
              timer: 2000,
            });
          } else if (
            self.user.password == null &&
            self.user.confirmpassword == null
          ) {
            self.$swal.fire({
              icon: "warning",
              title: self.$t("warning"),
              text: self.$t("Please fill Password and Confirm Password"),
              showConfirmButton: false,
              timer: 2000,
            });
          } else if (
            self.user.password == null &&
            self.user.confirmpassword != null
          ) {
            self.$swal.fire({
              icon: "warning",
              title: self.$t("warning"),
              text: self.$t("Please fill Password"),
              showConfirmButton: false,
              timer: 2000,
            });
          } else if (
            self.user.password != null &&
            self.user.confirmpassword == null
          ) {
            self.$swal.fire({
              icon: "warning",
              title: self.$t("warning"),
              text: self.$t("Please fill Confirm Password"),
              showConfirmButton: false,
              timer: 2000,
            });
          } else if (
            self.user.password != self.user.confirmpassword &&
            self.checkPasswordMatch == false
          ) {
            self.$swal.fire({
              icon: "warning",
              title: self.$t("warning"),
              text: self.$t(
                "Password and Confirm Password do not match.Please fill correctly."
              ),
              showConfirmButton: false,
              timer: 2000,
            });
          } else if (self.user.roleId == null) {
            self.$swal.fire({
              icon: "warning",
              title: self.$t("warning"),
              text: self.$t("Please fill correct format!"),
              showConfirmButton: false,
              timer: 2000,
            });
          }
          self.formHasErrors = true;
          self.Adddialog = true;
          self.dialog = false;
        }
      } catch (error) {
        this.LogTrace(error, "AddUser");
      }
    },
    closeChangePassword() {
      let self = this;
      self.edit.password = null;
      self.edit.confirmpassword = null;
      self.checkLengthPassword = true;
      self.checkLowercaseLetter = true;
      self.checkUppercaseLetter = true;
      self.checkNumber = true;
      self.checkSpecialCharacter = true;
      self.checkPasswordMatch = true;
      self.changPasswordDialog = false;
      self.show3 = false;
      self.show4 = false;
    },
    saveChangePassword() {
      try {
        let self = this;
        self.dialog = true;
        if (
          self.edit.password != "" &&
          self.edit.confirmpassword != "" &&
          self.edit.password != null &&
          self.edit.confirmpassword != null &&
          self.edit.password != undefined &&
          self.edit.confirmpassword != undefined &&
          self.edit.password == self.edit.confirmpassword &&
          self.checkPasswordMatch == true &&
          self.checkLengthPassword &&
          self.checkLowercaseLetter &&
          self.checkUppercaseLetter &&
          self.checkNumber &&
          self.checkSpecialCharacter
        ) {
          let temp = {
            userID: self.edit.id,
            password: self.edit.password,
          };
          self.$call.SaveChangePasswordUserChat(
            temp,
            (dataResponse) => {
              if (dataResponse.status == 0) {
                self.$swal.fire({
                  icon: "success",
                  title: dataResponse.message,
                  showConfirmButton: false,
                  timer: 1500,
                });
                self.edit.password = null;
                self.edit.confirmpassword = null;
                self.checkLengthPassword = true;
                self.checkLowercaseLetter = true;
                self.checkUppercaseLetter = true;
                self.checkNumber = true;
                self.checkSpecialCharacter = true;
                self.checkPasswordMatch = true;
                self.changPasswordDialog = false;
                self.show3 = false;
                self.show4 = false;
              } else {
                self.$swal.fire({
                  icon: "warning",
                  title: dataResponse.data.message,
                  showConfirmButton: false,
                  timer: 1800,
                });
              }
              self.dialog = false;
            },
            (errorResource) => {
              self.dialog = false;
              console.error(errorResource);
            }
          );
        } else {
          // if ((self.edit.password == '' || self.edit.password == null || self.edit.password == undefined) &&
          //    (self.edit.confirmpassword != '' && self.edit.confirmpassword != null && self.edit.confirmpassword != undefined)) {
          //   self.$swal.fire({
          //     icon: 'warning',
          //     title: self.$t('warning'),
          //     text: self.$t('Please fill Password!'),
          //     showConfirmButton: false,
          //     timer: 2000,
          //   });
          // } else if ((self.edit.confirmpassword == '' || self.edit.confirmpassword == null || self.edit.confirmpassword == undefined || self.checkPasswordMatch) &&
          //   (self.edit.password != '' && self.edit.password != null && self.edit.password != undefined)) {
          //   self.$swal.fire({
          //     icon: 'warning',
          //     title: self.$t('warning'),
          //     text: self.$t('Please fill Confirm Password'),
          //     showConfirmButton: false,
          //     timer: 2000,
          //   });
          // }
          if (self.edit.password != null && self.edit.confirmpassword == null) {
            self.$swal.fire({
              icon: "warning",
              title: self.$t("warning"),
              text: self.$t("Please fill Confirm Password"),
              showConfirmButton: false,
              timer: 2000,
            });
          } else if (
            self.edit.password == null &&
            self.edit.confirmpassword != null
          ) {
            self.$swal.fire({
              icon: "warning",
              title: self.$t("warning"),
              text: self.$t("Please fill Password"),
              showConfirmButton: false,
              timer: 2000,
            });
          } else if (
            self.edit.password == null &&
            self.edit.confirmpassword == null
          ) {
            self.$swal.fire({
              icon: "warning",
              title: self.$t("warning"),
              text: self.$t("Please fill Password and Confirm Password"),
              showConfirmButton: false,
              timer: 2000,
            });
          } else if (
            !self.checkLengthPassword ||
            !self.checkLowercaseLetter ||
            !self.checkUppercaseLetter ||
            !self.checkNumber ||
            !self.checkSpecialCharacter
          ) {
            self.$swal.fire({
              icon: "warning",
              title: self.$t("warning"),
              text: self.$t("Please fill correct format!"),
              showConfirmButton: false,
              timer: 2000,
            });
          } else if (
            self.edit.password != self.edit.confirmpassword &&
            self.checkPasswordMatch == false
          ) {
            self.$swal.fire({
              icon: "warning",
              title: self.$t("warning"),
              text: self.$t(
                "Password and Confirm Password do not match.Please fill correctly."
              ),
              showConfirmButton: false,
              timer: 2000,
            });
          } else {
            self.$swal.fire({
              icon: "warning",
              title: self.$t("warning"),
              text: self.$t("Please fill all the fields!!!"),
              showConfirmButton: false,
              timer: 2000,
            });
          }
          self.formHasErrors = true;
          self.changPasswordDialog = true;
          self.dialog = false;
        }
      } catch (error) {
        this.LogTrace(error, "saveChangePassword");
      }
    },
    decryptData(encryptedText, key) {
      const decryptedBytes = CryptoJS.AES.decrypt(encryptedText, key);
      const decryptedText = decryptedBytes.toString(CryptoJS.enc.Utf8);
      return decryptedText;
    },
    decryptShiftData(encryptedText, shift) {
      let chars = encryptedText.split("");
      let decryptedChars = [];

      for (let i = 0; i < chars.length; i++) {
        let c = chars[i];

        if (/[a-zA-Z]/.test(c)) {
          let offset =
            c === c.toUpperCase() ? "A".charCodeAt(0) : "a".charCodeAt(0);
          c = String.fromCharCode(
            ((c.charCodeAt(0) - offset - shift + 26) % 26) + offset
          );
        } else if (/[0-9]/.test(c)) {
          c = String.fromCharCode(
            ((c.charCodeAt(0) - "0".charCodeAt(0) - shift + 10) % 10) +
              "0".charCodeAt(0)
          );
        }

        decryptedChars.push(c);
      }

      return decryptedChars.join("");
    },
    GetDDModelQuickGroup() {
      let self = this;
      self.$call.GetDDModelQuickGroup(
        (dataResponse) => {
          if (dataResponse.status == 0) {
            self.DDQuickModel = dataResponse.data;
          } else {
            self.DDQuickModel = [];
          }
        },
        (errorResource) => {
          console.error(errorResource);
        }
      );
    },
  },
};
</script>
<style scoped>
.card2 {
  border-radius: 10px !important;
  margin-bottom: 2rem;
  padding-top: 1rem;
}
.title {
  color: white;
}
.card {
  border-radius: 10px !important;
  height: 90vh;
  overflow: auto;
  margin: 0 0 2rem 0;
  padding: 0;
}
.flex {
  margin-left: 2rem;
  margin-right: 2rem;
}
.pass {
  display: none;
}

.failed {
  display: block;
  color: red;
}

.ChangePassword:hover {
  background-color: #1976d2 !important;
  color: white !important;
}

.action-controls {
  display: flex;
  align-items: center;
  background: rgba(0, 0, 0, 0.02);
  border-radius: 12px;
  padding: 4px 8px;
  border: 1px solid rgba(0, 0, 0, 0.06);
  transition: all 0.2s ease;
  min-width: 300px;
}

.action-controls:hover {
  background: rgba(0, 0, 0, 0.03);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.control-btn {
  margin: 0 4px;
  font-weight: 500;
  letter-spacing: 0.025em;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
}
.template-btn,
.import-btn,
.sync-btn {
  width: 120px;
  height: 36px;
}
.template-btn:hover {
  background: transparent !important;
  box-shadow: none;
  transform: translate(0);
}
/* Template Dialog Styles */
.template-dialog {
  border-radius: 16px !important;
  overflow: hidden;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);
  animation: slideInDown 0.3s ease-out;
}

.template-header {
  background: linear-gradient(135deg, #1976d2 0%, #1565c0 100%);
  color: white;
  padding: 20px 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.header-content {
  display: flex;
  align-items: center;
  gap: 16px;
}

.header-icon {
  font-size: 28px;
  opacity: 0.9;
}

/* .header-text {
  display: flex;
  flex-direction: column;
  gap: 4px;
} */

/* .dialog-title {
  font-size: 1.5rem;
  font-weight: 600;
  margin: 0;
  line-height: 1.2;
  color: white;
}

.dialog-subtitle {
  font-size: 0.875rem;
  opacity: 0.8;
  margin: 0;
  line-height: 1.3;
  color: white;
} */

.close-btn {
  color: rgba(255, 255, 255, 0.8) !important;
  transition: all 0.2s ease;
}

.close-btn:hover {
  color: white !important;
  background-color: rgba(255, 255, 255, 0.1) !important;
}

.template-content {
  padding: 24px;
  background-color: #fafafa;
}

.template-description {
  margin-bottom: 20px;
}

.alert-content {
  font-size: 0.875rem;
}

.template-instructions {
  margin: 8px 0 0 16px;
  padding: 0;
}

.template-instructions li {
  margin: 4px 0;
  line-height: 1.4;
  color: rgba(var(--v-theme-on-surface), 0.8);
}

.template-table-wrapper {
  background: white;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.template-table {
  background: white;
}

.template-table :deep(.v-data-table__wrapper) {
  border-radius: 12px;
}

.template-table :deep(.v-data-table-header) {
  background-color: #f5f5f5;
}

.template-table :deep(.v-data-table-header th) {
  font-weight: 600;
  color: #424242;
  font-size: 0.875rem;
  border-bottom: 2px solid #e0e0e0;
  padding: 16px 12px;
}

.template-row {
  transition: background-color 0.2s ease;
}

.template-row:hover {
  background-color: rgba(25, 118, 210, 0.04);
}

.download-cell {
  text-align: center;
  padding: 16px 12px;
}

.download-btn {
  text-transform: none;
  font-weight: 500;
  font-size: 0.875rem;
  border-radius: 8px;
  min-width: 100px;
  height: 36px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  transition: all 0.2s ease;
}

.download-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
}

.template-actions {
  background-color: #f8f9fa;
  padding: 16px 24px;
  gap: 12px;
}

.close-dialog-action-btn {
  text-transform: none;
  font-weight: 600;
  border-radius: 8px;
  height: 40px;
  padding: 0 24px;
  transition: all 0.2s ease;
}

.close-dialog-action-btn:hover {
  transform: translateY(-1px);
}

/* Animation */
@keyframes slideInDown {
  from {
    opacity: 0;
    transform: translateY(-30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Responsive Design */
@media (max-width: 768px) {
  .template-dialog {
    margin: 16px;
    max-width: calc(100vw - 32px) !important;
  }

  .template-header {
    padding: 16px 20px;
  }

  .header-content {
    gap: 12px;
  }

  .header-icon {
    font-size: 24px;
  }

  /* .dialog-title {
    font-size: 1.25rem;
  } */

  .template-content {
    padding: 16px;
  }

  .download-btn {
    font-size: 0.8rem;
    min-width: 90px;
    height: 32px;
  }

  .template-table :deep(.v-data-table-header th) {
    padding: 12px 8px;
    font-size: 0.8rem;
  }

  .download-cell {
    padding: 12px 8px;
  }
}

@media (max-width: 480px) {
  .template-dialog {
    margin: 8px;
    max-width: calc(100vw - 16px) !important;
  }

  .header-content {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }

  .dialog-title {
    font-size: 1.1rem;
  }

  .dialog-subtitle {
    font-size: 0.8rem;
  }

  .download-btn {
    font-size: 0.75rem;
    min-width: 80px;
    height: 30px;
  }
}

/* Common Dialog Styles */
.template-dialog,
.modern-dialog,
.modern-dialog,
.change-password-dialog {
  border-radius: 16px !important;
  overflow: hidden;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);
  animation: slideInDown 0.3s ease-out;
  z-index: 9;
}

/* Common Header Styles */
.template-header,
.dialog-header-success,
.edit-user-header,
.change-password-header {
  color: white;
  padding: 20px 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.dialog-header-success {
  background: linear-gradient(135deg, #4caf50 0%, #388e3c 100%);
}

.edit-user-header {
  background: linear-gradient(135deg, #2196f3 0%, #1976d2 100%);
}

.change-password-header {
  background: linear-gradient(135deg, #ff9800 0%, #f57c00 100%);
}

/* Common Header Content */
/* .header-content {
  display: flex;
  align-items: center;
  gap: 16px;
}

.header-icon {
  font-size: 28px;
  opacity: 0.9;
} */

/* .header-text {
  display: flex;
  flex-direction: column;
  gap: 4px;
} */
/* 
.dialog-title {
  font-size: 1.5rem;
  font-weight: 600;
  margin: 0;
  line-height: 1.2;
  color: white;
}

.dialog-subtitle {
  font-size: 0.875rem;
  opacity: 0.8;
  margin: 0;
  line-height: 1.3;
  color: white;
}

.close-btn {
  color: rgba(255, 255, 255, 0.8) !important;
  transition: all 0.2s ease;
}

.close-btn:hover {
  color: white !important;
  background-color: rgba(255, 255, 255, 0.1) !important;
} */

/* Common Content Styles */
.add-user-content,
.edit-user-content,
.change-password-content {
  padding: 24px;
  background-color: #fafafa;
  max-height: 70vh;
  overflow-y: auto;
}

.change-password-content {
  contain: layout;
}

/* Form Sections */
.form-section {
  margin-bottom: 24px;
  transition: all 0.3s ease;
}

.section-title {
  display: flex;
  align-items: center;
  font-size: 1.1rem;
  font-weight: 600;
  color: rgb(var(--v-theme-on-surface));
  margin-bottom: 16px;
  padding-bottom: 8px;
  border-bottom: 2px solid rgba(var(--v-theme-primary), 0.1);
}

.section-divider {
  margin: 20px 0;
  opacity: 0.6;
}

.form-row {
  margin-bottom: 8px;
}

.form-row .v-col {
  padding-top: 8px;
  padding-bottom: 8px;
}

/* Input Styling */
.input-wrapper {
  display: flex;
  flex-direction: column;
  gap: 8px;
  position: relative;
  min-height: 60px;
}

.input-wrapper:has(.password-requirements) {
  min-height: 200px;
}

.input-wrapper:has(.password-match) {
  min-height: 120px;
}

.input-label {
  font-size: 0.875rem;
  font-weight: 600;
  color: rgb(var(--v-theme-on-surface));
  opacity: 0.87;
  line-height: 1.2;
}

.modern-input :deep(.v-field) {
  background: white;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  transition: all 0.2s ease;
}

.modern-input :deep(.v-field--focused) {
  box-shadow: 0 2px 8px rgba(var(--v-theme-primary), 0.15);
}

.modern-input :deep(.v-field__outline) {
  --v-field-border-opacity: 0.25;
}

.modern-input :deep(.v-field--focused .v-field__outline) {
  --v-field-border-opacity: 1;
  --v-field-border-width: 2px;
}

.password-toggle {
  margin: 0 !important;
}

/* Password Requirements */
.password-requirements,
.password-match {
  margin-top: 8px;
  background: white;
  border-radius: 8px;
  border: 1px solid rgba(var(--v-border-color), 0.12);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
}

.password-requirements {
  padding: 12px;
  overflow: hidden;
  min-height: 120px;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}

.password-match {
  padding: 8px 12px;
  min-height: 40px;
  display: flex;
  align-items: center;
}

.requirement-item {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 0.8rem;
  margin: 4px 0;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  padding: 4px 6px;
  border-radius: 6px;
  opacity: 0;
  transform: translateX(-10px);
  animation: slideInRequirement 0.4s ease-out forwards;
}

.requirement-item:nth-child(1) {
  animation-delay: 0.1s;
}
.requirement-item:nth-child(2) {
  animation-delay: 0.15s;
}
.requirement-item:nth-child(3) {
  animation-delay: 0.2s;
}
.requirement-item:nth-child(4) {
  animation-delay: 0.25s;
}
.requirement-item:nth-child(5) {
  animation-delay: 0.3s;
}

.requirement-item.valid {
  color: rgb(var(--v-theme-success));
  background: rgba(var(--v-theme-success), 0.08);
  border-left: 3px solid rgb(var(--v-theme-success));
}

.requirement-item:not(.valid) {
  color: rgb(var(--v-theme-error));
  background: rgba(var(--v-theme-error), 0.08);
  border-left: 3px solid rgb(var(--v-theme-error));
}

/* Switch Wrapper */
.switch-wrapper {
  background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
  border-radius: 12px;
  padding: 20px;
  border: 1px solid rgba(var(--v-border-color), 0.12);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
  cursor: pointer;
  user-select: none;
}

.switch-wrapper::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 3px;
  background: linear-gradient(
    90deg,
    rgba(var(--v-theme-success), 0.3) 0%,
    rgba(var(--v-theme-success), 0.1) 100%
  );
  transition: all 0.3s ease;
}

.switch-wrapper:has(.modern-switch input:checked)::before {
  background: linear-gradient(
    90deg,
    rgba(var(--v-theme-error), 0.3) 0%,
    rgba(var(--v-theme-error), 0.1) 100%
  );
}

.switch-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
}

.switch-info {
  display: flex;
  align-items: center;
  gap: 16px;
  flex: 1;
}

.lock-icon-container {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: rgba(76, 175, 80, 0.15) !important;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  overflow: hidden;
}

.lock-icon-container:has(.locked) {
  background: rgba(244, 67, 54, 0.15) !important;
}

.lock-icon {
  font-size: 24px !important;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  z-index: 2;
  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.1));
}

.switch-title {
  font-size: 1rem;
  font-weight: 700;
  color: rgb(var(--v-theme-on-surface));
  margin-bottom: 4px;
  transition: color 0.3s ease;
}

.switch-subtitle {
  font-size: 0.85rem;
  color: rgba(var(--v-theme-on-surface), 0.7);
  margin-top: 2px;
  line-height: 1.4;
  max-width: 300px;
  transition: color 0.3s ease;
}

.switch-control {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 8px;
}

.modern-switch {
  margin: 0;
}

.modern-switch :deep(.v-selection-control) {
  min-height: auto;
}

.modern-switch :deep(.v-switch__track) {
  background-color: rgba(var(--v-theme-surface-variant), 0.5) !important;
  border: 2px solid rgba(var(--v-border-color), 0.2);
  transition: all 0.3s ease;
}

.modern-switch :deep(.v-selection-control--dirty .v-switch__track) {
  background-color: rgba(var(--v-theme-error), 0.1) !important;
  border-color: rgba(var(--v-theme-error), 0.3);
}

.switch-label {
  font-size: 0.9rem;
  font-weight: 600;
  transition: all 0.3s ease;
  padding: 4px 8px;
  border-radius: 6px;
  margin-left: 8px;
}

.switch-label.locked-text {
  color: rgb(var(--v-theme-error));
  background: rgba(var(--v-theme-error), 0.08);
}

.switch-label.unlocked-text {
  color: rgb(var(--v-theme-success));
  background: rgba(var(--v-theme-success), 0.08);
}

/* Action Buttons */
.add-user-actions,
.edit-user-actions,
.change-password-actions {
  background-color: #f8f9fa;
  padding: 16px 24px;
  gap: 12px;
}

.edit-user-actions {
  display: flex;
  align-items: center;
}

.dialog-action-btn,
.cancel-btn,
.save-btn {
  text-transform: none;
  font-weight: 600;
  border-radius: 8px;
  height: 44px;
  min-width: 120px;
  transition: all 0.2s ease;
}

.dialog-action-btn {
  padding: 0 20px;
  height: 40px;
  min-width: 140px;
}

/* .cancel-btn,
.save-btn {
  padding: 0 24px;
} */

/* .cancel-btn:hover {
  background-color: rgba(var(--v-theme-surface), 0.8);
  transform: translateY(-1px);
}

.dialog-action-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(33, 150, 243, 0.3);
}

.save-btn:hover:not(:disabled) {
  transform: translateY(-1px);
} */

/* .add-user-actions .save-btn {
  background: linear-gradient(135deg, #4caf50 0%, #388e3c 100%);
}

.add-user-actions .save-btn:hover {
  background: linear-gradient(135deg, #388e3c 0%, #2e7d32 100%);
  box-shadow: 0 4px 12px rgba(76, 175, 80, 0.4);
}

.edit-user-actions .save-btn {
  background: linear-gradient(135deg, #2196f3 0%, #1976d2 100%);
}

.edit-user-actions .save-btn:hover {
  background: linear-gradient(135deg, #1976d2 0%, #1565c0 100%);
  box-shadow: 0 4px 12px rgba(33, 150, 243, 0.4);
} */

/* Responsive Design */
@media (max-width: 768px) {
  .modern-dialog,
  .modern-dialog,
  .change-password-dialog {
    margin: 16px;
    max-width: calc(100vw - 32px) !important;
  }

  .dialog-header-success,
  .edit-user-header,
  .change-password-header {
    padding: 16px 20px;
  }

  .add-user-content,
  .edit-user-content,
  .change-password-content {
    padding: 16px;
    max-height: 60vh;
  }

  .switch-content {
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
  }

  .switch-control {
    align-items: flex-start;
    width: 100%;
  }

  .edit-user-actions {
    flex-direction: column;
    gap: 8px;
  }

  .dialog-action-btn {
    width: 100%;
    order: 1;
  }

  .cancel-btn {
    width: 100%;
    order: 2;
  }

  .save-btn {
    width: 100%;
    order: 3;
  }
}

@media (max-width: 480px) {
  .modern-dialog,
  .modern-dialog,
  .change-password-dialog {
    margin: 8px;
    max-width: calc(100vw - 16px) !important;
  }

  .add-user-actions,
  .change-password-actions {
    flex-direction: column;
    gap: 8px;
  }

  .cancel-btn,
  .save-btn {
    width: 100%;
  }
}
/* Common Dialog Styles */
.template-dialog,
.modern-dialog,
.modern-dialog,
.change-password-dialog {
  border-radius: 16px !important;
  overflow: hidden;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);
  animation: slideInDown 0.3s ease-out;
}

/* Common Header Styles */
.template-header,
.dialog-header-success,
.edit-user-header,
.change-password-header {
  color: white;
  padding: 20px 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.template-header {
  background: linear-gradient(135deg, #1976d2 0%, #1565c0 100%);
}

.dialog-header-success {
  background: linear-gradient(135deg, #4caf50 0%, #388e3c 100%);
}

.edit-user-header {
  background: linear-gradient(135deg, #2196f3 0%, #1976d2 100%);
}

.change-password-header {
  background: linear-gradient(135deg, #ff9800 0%, #f57c00 100%);
}

/* Common Header Content */
/* .header-content {
  display: flex;
  align-items: center;
  gap: 16px;
}

.header-icon {
  font-size: 28px;
  opacity: 0.9;
} */

/* .header-text {
  display: flex;
  flex-direction: column;
  gap: 4px;
} */

/* .dialog-title {
  font-size: 1.5rem;
  font-weight: 600;
  margin: 0;
  line-height: 1.2;
  color: white;
}

.dialog-subtitle {
  font-size: 0.875rem;
  opacity: 0.8;
  margin: 0;
  line-height: 1.3;
  color: white;
}

.close-btn {
  color: rgba(255, 255, 255, 0.8) !important;
  transition: all 0.2s ease;
}

.close-btn:hover {
  color: white !important;
  background-color: rgba(255, 255, 255, 0.1) !important;
} */

/* Common Content Styles */
.template-content,
.add-user-content,
.edit-user-content,
.change-password-content {
  padding: 24px;
  background-color: #fafafa;
}

.add-user-content,
.edit-user-content,
.change-password-content {
  max-height: 70vh;
  overflow-y: auto;
}

.change-password-content {
  contain: layout;
}

/* Form Sections */
.form-section {
  margin-bottom: 24px;
  transition: all 0.3s ease;
}

.section-title {
  display: flex;
  align-items: center;
  font-size: 1.1rem;
  font-weight: 600;
  color: rgb(var(--v-theme-on-surface));
  margin-bottom: 16px;
  padding-bottom: 8px;
  border-bottom: 2px solid rgba(var(--v-theme-primary), 0.1);
}

.section-divider {
  margin: 20px 0;
  opacity: 0.6;
}

.form-row {
  margin-bottom: 8px;
}

.form-row .v-col {
  padding-top: 8px;
  padding-bottom: 8px;
}

/* Input Styling */
.input-wrapper {
  display: flex;
  flex-direction: column;
  gap: 8px;
  position: relative;
  min-height: 60px;
}

.input-wrapper:has(.password-requirements) {
  min-height: 200px;
}

.input-wrapper:has(.password-match) {
  min-height: 120px;
}

.input-label {
  font-size: 0.875rem;
  font-weight: 600;
  color: rgb(var(--v-theme-on-surface));
  opacity: 0.87;
  line-height: 1.2;
}

.modern-input :deep(.v-field) {
  background: white;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  transition: all 0.2s ease;
}

.modern-input :deep(.v-field--focused) {
  box-shadow: 0 2px 8px rgba(var(--v-theme-primary), 0.15);
}

.change-password-content .modern-input :deep(.v-field--focused) {
  box-shadow: 0 2px 8px rgba(255, 152, 0, 0.15);
}

.change-password-content
  .modern-input
  :deep(.v-field--focused .v-field__outline) {
  border-color: #ff9800;
}

.modern-input :deep(.v-field__outline) {
  --v-field-border-opacity: 0.25;
}

.modern-input :deep(.v-field--focused .v-field__outline) {
  --v-field-border-opacity: 1;
  --v-field-border-width: 2px;
}

.help-icon {
  color: rgba(var(--v-theme-primary), 0.7);
  cursor: help;
  transition: color 0.2s ease;
}

.help-icon:hover {
  color: rgb(var(--v-theme-primary));
}

.password-toggle {
  margin: 0 !important;
}

/* Password Requirements */
.password-requirements,
.password-match {
  margin-top: 8px;
  background: white;
  border-radius: 8px;
  border: 1px solid rgba(var(--v-border-color), 0.12);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
}

.password-requirements {
  padding: 12px;
  overflow: hidden;
  min-height: 120px;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}

.password-match {
  padding: 8px 12px;
  min-height: 40px;
  display: flex;
  align-items: center;
}

.requirement-item {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 0.8rem;
  margin: 4px 0;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  padding: 4px 6px;
  border-radius: 6px;
  opacity: 0;
  transform: translateX(-10px);
  animation: slideInRequirement 0.4s ease-out forwards;
}

.requirement-item:nth-child(1) {
  animation-delay: 0.1s;
}
.requirement-item:nth-child(2) {
  animation-delay: 0.15s;
}
.requirement-item:nth-child(3) {
  animation-delay: 0.2s;
}
.requirement-item:nth-child(4) {
  animation-delay: 0.25s;
}
.requirement-item:nth-child(5) {
  animation-delay: 0.3s;
}

.requirement-item.valid {
  color: rgb(var(--v-theme-success));
  background: rgba(var(--v-theme-success), 0.08);
  border-left: 3px solid rgb(var(--v-theme-success));
}

.requirement-item:not(.valid) {
  color: rgb(var(--v-theme-error));
  background: rgba(var(--v-theme-error), 0.08);
  border-left: 3px solid rgb(var(--v-theme-error));
}

/* Password Strength Indicator */
.password-strength-wrapper {
  background: white;
  border-radius: 12px;
  padding: 16px;
  border: 1px solid rgba(var(--v-border-color), 0.12);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  margin-top: 8px;
  min-height: 80px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.strength-label {
  display: flex;
  align-items: center;
  font-size: 0.875rem;
  font-weight: 600;
  margin-bottom: 8px;
  color: rgb(var(--v-theme-on-surface));
  transition: all 0.3s ease;
}

.strength-text {
  font-weight: 700;
  margin-left: 4px;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  display: inline-block;
}

.strength-bar {
  border-radius: 6px;
  overflow: hidden;
  position: relative;
}

.strength-bar :deep(.v-progress-linear__background) {
  background-color: rgba(var(--v-border-color), 0.15) !important;
  transition: all 0.3s ease;
}

.strength-bar :deep(.v-progress-linear__determinate) {
  transition: all 0.6s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
}

.strength-bar :deep(.v-progress-linear__determinate)::after {
  content: "";
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    90deg,
    transparent,
    rgba(255, 255, 255, 0.4),
    transparent
  );
  animation: shimmer 2s infinite;
}

/* Role Selection */
.role-selection-container-compact {
  background: white;
  border-radius: 8px;
  padding: 12px;
  border: 1px solid rgba(var(--v-border-color), 0.12);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
}

.role-radio-group-compact {
  margin: 0;
}

.role-cards-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));
  gap: 8px;
}

.role-card-compact {
  position: relative;
  background: #f8f9fa;
  border: 1.5px solid rgba(var(--v-border-color), 0.2);
  border-radius: 8px;
  padding: 10px;
  cursor: pointer;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  min-height: 70px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.role-card-compact:hover {
  border-color: rgba(var(--v-theme-primary), 0.4);
  background: rgba(var(--v-theme-primary), 0.03);
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(var(--v-theme-primary), 0.12);
}

.role-card-compact.selected {
  border-color: rgb(var(--v-theme-primary));
  background: rgba(var(--v-theme-primary), 0.08);
  box-shadow: 0 2px 12px rgba(var(--v-theme-primary), 0.2);
}

.role-card-compact.disabled {
  opacity: 0.6;
  cursor: not-allowed;
  background: #e0e0e0 !important;
  border-color: #bdbdbd !important;
}

.role-card-compact.disabled:hover {
  transform: none !important;
  box-shadow: none !important;
  border-color: #bdbdbd !important;
  background: #e0e0e0 !important;
}

.role-badge {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 6px;
}

.role-icon-compact {
  font-size: 20px !important;
  filter: drop-shadow(0 1px 2px rgba(0, 0, 0, 0.1));
}

.role-radio-compact {
  margin: 0;
  padding: 0;
}

.role-radio-compact :deep(.v-selection-control) {
  min-height: auto;
  margin: 0;
}

.role-radio-compact :deep(.v-selection-control__wrapper) {
  height: 16px;
  width: 16px;
}

.role-details {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column-reverse;
}

.role-title-compact {
  font-size: 0.85rem;
  font-weight: 600;
  margin: 0;
  color: rgb(var(--v-theme-on-surface));
  line-height: 1.2;
  text-align: center;
}

.role-chip {
  align-self: center;
  height: 25px !important;
}

/* Role Card Colors */
.role-card-compact:nth-child(1):hover {
  border-color: rgba(244, 67, 54, 0.4);
  background: rgba(244, 67, 54, 0.03);
  box-shadow: 0 2px 8px rgba(244, 67, 54, 0.12);
}

.role-card-compact:nth-child(1).selected {
  border-color: #f44336;
  background: rgba(244, 67, 54, 0.08);
  box-shadow: 0 2px 12px rgba(244, 67, 54, 0.2);
}

.role-card-compact:nth-child(2):hover {
  border-color: rgba(255, 152, 0, 0.4);
  background: rgba(255, 152, 0, 0.03);
  box-shadow: 0 2px 8px rgba(255, 152, 0, 0.12);
}

.role-card-compact:nth-child(2).selected {
  border-color: #ff9800;
  background: rgba(255, 152, 0, 0.08);
  box-shadow: 0 2px 12px rgba(255, 152, 0, 0.2);
}

.role-card-compact:nth-child(3):hover {
  border-color: rgba(var(--v-theme-primary), 0.4);
  background: rgba(var(--v-theme-primary), 0.03);
  box-shadow: 0 2px 8px rgba(var(--v-theme-primary), 0.12);
}

.role-card-compact:nth-child(3).selected {
  border-color: rgb(var(--v-theme-primary));
  background: rgba(var(--v-theme-primary), 0.08);
  box-shadow: 0 2px 12px rgba(var(--v-theme-primary), 0.2);
}

.role-card-compact:nth-child(4):hover {
  border-color: rgba(156, 39, 176, 0.4);
  background: rgba(156, 39, 176, 0.03);
  box-shadow: 0 2px 8px rgba(156, 39, 176, 0.12);
}

.role-card-compact:nth-child(4).selected {
  border-color: #9c27b0;
  background: rgba(156, 39, 176, 0.08);
  box-shadow: 0 2px 12px rgba(156, 39, 176, 0.2);
}

/* Switch Wrapper */
.switch-wrapper {
  background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
  border-radius: 12px;
  padding: 20px;
  border: 1px solid rgba(var(--v-border-color), 0.12);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
  cursor: pointer;
  user-select: none;
}

.switch-wrapper::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 3px;
  background: linear-gradient(
    90deg,
    rgba(var(--v-theme-success), 0.3) 0%,
    rgba(var(--v-theme-success), 0.1) 100%
  );
  transition: all 0.3s ease;
}

.switch-wrapper:has(.modern-switch input:checked)::before {
  background: linear-gradient(
    90deg,
    rgba(var(--v-theme-error), 0.3) 0%,
    rgba(var(--v-theme-error), 0.1) 100%
  );
}

.switch-wrapper:has(.modern-switch input:checked) {
  box-shadow: 0 2px 16px rgba(var(--v-theme-error), 0.1);
}

.switch-wrapper:has(.modern-switch input:not(:checked)) {
  box-shadow: 0 2px 16px rgba(var(--v-theme-success), 0.1);
}

.switch-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
}

.switch-info {
  display: flex;
  align-items: center;
  gap: 16px;
  flex: 1;
}

.lock-icon-container {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: rgba(170, 213, 157, 0.242) !important;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  overflow: hidden;
}

.lock-icon-container:has(.locked) {
  background: rgba(156, 61, 61, 0.242) !important;
}

.lock-icon {
  font-size: 24px !important;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  z-index: 2;
  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.1));
}

.lock-icon.locked {
  animation: lockShake 0.6s ease-in-out;
  transform-origin: center;
}

.lock-icon.unlocked {
  animation: unlockBounce 0.8s ease-out;
  transform-origin: center;
}

.switch-title {
  font-size: 1rem;
  font-weight: 700;
  color: rgb(var(--v-theme-on-surface));
  margin-bottom: 4px;
  transition: color 0.3s ease;
}

.switch-subtitle {
  font-size: 0.85rem;
  color: rgba(var(--v-theme-on-surface), 0.7);
  margin-top: 2px;
  line-height: 1.4;
  max-width: 300px;
  transition: color 0.3s ease;
}

.switch-control {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 8px;
}

.modern-switch {
  margin: 0;
}

.modern-switch :deep(.v-selection-control) {
  min-height: auto;
}

.modern-switch :deep(.v-switch__track) {
  background-color: rgba(var(--v-theme-surface-variant), 0.5) !important;
  border: 2px solid rgba(var(--v-border-color), 0.2);
  transition: all 0.3s ease;
}

.modern-switch :deep(.v-selection-control--dirty .v-switch__track) {
  background-color: rgba(var(--v-theme-error), 0.1) !important;
  border-color: rgba(var(--v-theme-error), 0.3);
}

.modern-switch :deep(.v-switch__thumb) {
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

.switch-label {
  font-size: 0.9rem;
  font-weight: 600;
  transition: all 0.3s ease;
  padding: 4px 8px;
  border-radius: 6px;
  margin-left: 8px;
}

.switch-label.locked-text {
  color: rgb(var(--v-theme-error));
  background: rgba(var(--v-theme-error), 0.08);
}

.switch-label.unlocked-text {
  color: rgb(var(--v-theme-success));
  background: rgba(var(--v-theme-success), 0.08);
}

/* Template Table */
.template-table-wrapper {
  background: white;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.template-table {
  background: white;
}

.template-table :deep(.v-data-table__wrapper) {
  border-radius: 12px;
}

.template-table :deep(.v-data-table-header) {
  background-color: #f5f5f5;
}

.template-table :deep(.v-data-table-header th) {
  font-weight: 600;
  color: #424242;
  font-size: 0.875rem;
  border-bottom: 2px solid #e0e0e0;
  padding: 16px 12px;
}

.template-row {
  transition: background-color 0.2s ease;
}

.template-row:hover {
  background-color: rgba(25, 118, 210, 0.04);
}

.download-cell {
  text-align: center;
  padding: 16px 12px;
}

.download-btn {
  text-transform: none;
  font-weight: 500;
  font-size: 0.875rem;
  border-radius: 8px;
  min-width: 100px;
  height: 36px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  transition: all 0.2s ease;
}

.download-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
}

/* Security Tips */
.security-tips {
  margin-top: 20px;
  animation: fadeInUp 0.5s ease-out 0.3s both;
}

.security-alert {
  border-radius: 12px;
  border: 1px solid rgba(var(--v-theme-info), 0.2);
  overflow: hidden;
  transition: all 0.3s ease;
}

.security-alert:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(var(--v-theme-info), 0.15);
}

.alert-content {
  font-size: 0.875rem;
}

.tips-list {
  margin: 8px 0 0 16px;
  padding: 0;
}

.tips-list li {
  margin: 4px 0;
  line-height: 1.4;
  color: rgba(var(--v-theme-on-surface), 0.8);
  opacity: 0;
  transform: translateX(-10px);
  animation: slideInTip 0.4s ease-out forwards;
}

.tips-list li:nth-child(1) {
  animation-delay: 0.9s;
}
.tips-list li:nth-child(2) {
  animation-delay: 1s;
}
.tips-list li:nth-child(3) {
  animation-delay: 1.1s;
}
.tips-list li:nth-child(4) {
  animation-delay: 1.2s;
}

/* Action Buttons */
.template-actions,
.add-user-actions,
.edit-user-actions,
.change-password-actions {
  background-color: #f8f9fa;
  padding: 16px 24px;
  gap: 12px;
}

.edit-user-actions {
  display: flex;
  align-items: center;
}

/* .close-dialog-action-btn,
.dialog-action-btn,
.cancel-btn,
.save-btn {
  text-transform: none;
  font-weight: 600;
  border-radius: 8px;
  height: 44px;
  min-width: 120px;
  transition: all 0.2s ease;
}

.close-dialog-action-btn {
  padding: 0 24px;
  height: 40px;
} */

/* .dialog-action-btn {
  padding: 0 20px;
  height: 40px;
  min-width: 140px;
}

.cancel-btn,
.save-btn {
  padding: 0 24px;
} */

/* .cancel-btn:hover,
.close-dialog-action-btn:hover {
  background-color: rgba(var(--v-theme-surface), 0.8);
  transform: translateY(-1px);
}

.dialog-action-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(33, 150, 243, 0.3);
}

.save-btn:hover:not(:disabled) {
  transform: translateY(-1px);
}

.add-user-actions .save-btn {
  background: linear-gradient(135deg, #4caf50 0%, #388e3c 100%);
}

.add-user-actions .save-btn:hover {
  background: linear-gradient(135deg, #388e3c 0%, #2e7d32 100%);
  box-shadow: 0 4px 12px rgba(76, 175, 80, 0.4);
}

.edit-user-actions .save-btn {
  background: linear-gradient(135deg, #2196f3 0%, #1976d2 100%);
}

.edit-user-actions .save-btn:hover {
  background: linear-gradient(135deg, #1976d2 0%, #1565c0 100%);
  box-shadow: 0 4px 12px rgba(33, 150, 243, 0.4);
} */

/* .change-password-actions .save-btn {
  background: linear-gradient(135deg, #ff9800 0%, #f57c00 100%);
}

.change-password-actions .save-btn:hover:not(:disabled) {
  background: linear-gradient(135deg, #f57c00 0%, #ef6c00 100%);
  box-shadow: 0 4px 12px rgba(255, 152, 0, 0.4);
}

.change-password-actions .save-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none !important;
  box-shadow: none !important;
} */

/* Animations */
@keyframes slideInDown {
  from {
    opacity: 0;
    transform: translateY(-30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes slideInRequirement {
  from {
    opacity: 0;
    transform: translateX(-10px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

@keyframes slideInTip {
  from {
    opacity: 0;
    transform: translateX(-10px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes shimmer {
  0% {
    left: -100%;
  }
  100% {
    left: 100%;
  }
}

@keyframes lockShake {
  0%,
  100% {
    transform: translateX(0) scale(1);
  }
  10%,
  30%,
  50%,
  70%,
  90% {
    transform: translateX(-2px) scale(1.05);
  }
  20%,
  40%,
  60%,
  80% {
    transform: translateX(2px) scale(1.05);
  }
}

@keyframes unlockBounce {
  0% {
    transform: scale(1) rotate(0deg);
  }
  20% {
    transform: scale(1.2) rotate(-5deg);
  }
  40% {
    transform: scale(1.1) rotate(5deg);
  }
  60% {
    transform: scale(1.15) rotate(-3deg);
  }
  80% {
    transform: scale(1.05) rotate(2deg);
  }
  100% {
    transform: scale(1) rotate(0deg);
  }
}

/* Vue Transitions */
.slide-fade-enter-active {
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
}

.slide-fade-leave-active {
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.slide-fade-enter-from {
  opacity: 0;
  transform: translateY(-10px) scale(0.95);
  filter: blur(2px);
}

.slide-fade-leave-to {
  opacity: 0;
  transform: translateY(-5px) scale(0.98);
  filter: blur(1px);
}

.slide-fade-enter-to,
.slide-fade-leave-from {
  opacity: 1;
  transform: translateY(0) scale(1);
  filter: blur(0);
}

.expand-fade-enter-active {
  transition: all 0.5s cubic-bezier(0.4, 0, 0.2, 1);
}

.expand-fade-leave-active {
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
}

.expand-fade-enter-from {
  opacity: 0;
  transform: translateY(-15px) scaleY(0.8);
  max-height: 0;
  padding-top: 0;
  padding-bottom: 0;
  margin-top: 0;
}

.expand-fade-leave-to {
  opacity: 0;
  transform: translateY(-10px) scaleY(0.9);
  max-height: 0;
  padding-top: 0;
  padding-bottom: 0;
  margin-top: 0;
}

.expand-fade-enter-to,
.expand-fade-leave-from {
  opacity: 1;
  transform: translateY(0) scaleY(1);
  max-height: 200px;
  padding-top: 8px;
  padding-bottom: 8px;
  margin-top: 8px;
}

/* Responsive Design */
@media (max-width: 768px) {
  /* Dialog sizes */
  .template-dialog,
  .modern-dialog,
  .modern-dialog,
  .change-password-dialog {
    margin: 16px;
    max-width: calc(100vw - 32px) !important;
  }

  /* Headers */
  .template-header,
  .dialog-header-success,
  .edit-user-header,
  .change-password-header {
    padding: 16px 20px;
  }

  .header-content {
    gap: 12px;
  }

  .header-icon {
    font-size: 24px;
  }

  .dialog-title {
    font-size: 1.25rem;
  }

  /* Content */
  .template-content,
  .add-user-content,
  .edit-user-content,
  .change-password-content {
    padding: 16px;
  }

  .add-user-content,
  .edit-user-content,
  .change-password-content {
    max-height: 60vh;
  }

  /* Role cards */
  .role-cards-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 6px;
  }

  .role-card-compact {
    padding: 8px;
    min-height: 60px;
  }

  .role-icon-compact {
    font-size: 18px !important;
  }

  .role-title-compact {
    font-size: 0.8rem;
  }

  /* Switch */
  .switch-content {
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
  }

  .switch-control {
    align-items: flex-start;
    width: 100%;
  }

  .lock-icon-container {
    width: 40px;
    height: 40px;
  }

  .lock-icon {
    font-size: 20px !important;
  }

  .switch-title {
    font-size: 0.9rem;
  }

  .switch-subtitle {
    font-size: 0.8rem;
    max-width: none;
  }

  /* Password */
  .password-requirements {
    min-height: 100px;
    padding: 10px;
  }

  .password-strength-wrapper {
    min-height: 70px;
    padding: 12px;
  }

  .input-wrapper:has(.password-requirements) {
    min-height: 180px;
  }

  .input-wrapper:has(.password-match) {
    min-height: 100px;
  }

  .requirement-item {
    font-size: 0.75rem;
    padding: 3px 5px;
  }

  .strength-label {
    font-size: 0.8rem;
  }

  /* Buttons */
  .dialog-action-btn,
  .cancel-btn,
  .save-btn {
    min-width: 100px;
    height: 40px;
  }

  .edit-user-actions {
    flex-direction: column;
    gap: 8px;
  }

  .dialog-action-btn {
    width: 100%;
    order: 1;
  }

  .cancel-btn {
    width: 100%;
    order: 2;
  }

  .save-btn {
    width: 100%;
    order: 3;
  }

  /* Template */
  .download-btn {
    font-size: 0.8rem;
    min-width: 90px;
    height: 32px;
  }

  .template-table :deep(.v-data-table-header th) {
    padding: 12px 8px;
    font-size: 0.8rem;
  }

  .download-cell {
    padding: 12px 8px;
  }

  .tips-list {
    font-size: 0.8rem;
  }

  /* Animations */
  .slide-fade-enter-active,
  .expand-fade-enter-active {
    transition-duration: 0.3s;
  }

  .requirement-item {
    animation-duration: 0.3s;
  }
}

@media (max-width: 480px) {
  /* Dialog sizes */
  .template-dialog,
  .modern-dialog,
  .modern-dialog,
  .change-password-dialog {
    margin: 8px;
    max-width: calc(100vw - 16px) !important;
  }

  /* Headers */
  .header-content {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }

  .dialog-title {
    font-size: 1.1rem;
  }

  .dialog-subtitle {
    font-size: 0.8rem;
  }

  /* Role cards */
  .role-selection-container-compact {
    padding: 8px;
  }

  .role-cards-grid {
    grid-template-columns: 1fr 1fr;
    gap: 4px;
  }

  .role-card-compact {
    padding: 6px;
    min-height: 55px;
  }

  .role-icon-compact {
    font-size: 16px !important;
  }

  .role-title-compact {
    font-size: 0.75rem;
  }

  /* Switch */
  .switch-wrapper {
    padding: 16px;
  }

  .switch-info {
    gap: 12px;
  }

  .lock-icon-container {
    width: 36px;
    height: 36px;
  }

  .lock-icon {
    font-size: 18px !important;
  }

  .switch-title {
    font-size: 0.85rem;
  }

  .switch-subtitle {
    font-size: 0.75rem;
  }

  .switch-label {
    font-size: 0.8rem;
  }

  /* Password */
  .password-requirements {
    min-height: 90px;
    padding: 8px;
  }

  .password-strength-wrapper {
    min-height: 60px;
    padding: 10px;
  }

  .input-wrapper:has(.password-requirements) {
    min-height: 160px;
  }

  .input-wrapper:has(.password-match) {
    min-height: 90px;
  }

  /* Buttons */
  .add-user-actions,
  .change-password-actions {
    flex-direction: column;
    gap: 8px;
  }

  .cancel-btn,
  .save-btn {
    width: 100%;
  }

  .dialog-action-btn,
  .cancel-btn,
  .save-btn {
    height: 40px;
    font-size: 0.9rem;
  }

  /* Others */
  .section-title {
    font-size: 1rem;
  }

  .download-btn {
    font-size: 0.75rem;
    min-width: 80px;
    height: 30px;
  }
}

/* Accessibility and Performance */
.role-card-compact:focus-visible {
  outline: 2px solid rgb(var(--v-theme-primary));
  outline-offset: 1px;
}

.modern-switch:focus-within .lock-icon-container {
  outline: 2px solid rgb(var(--v-theme-primary));
  outline-offset: 2px;
}

.change-password-dialog :deep(.v-btn:focus-visible) {
  outline: 2px solid rgb(var(--v-theme-primary));
  outline-offset: 2px;
}

.switch-wrapper:hover .lock-icon-container {
  transform: scale(1.05);
}

.switch-wrapper:active .lock-icon-container {
  transform: scale(0.95);
}

.switch-wrapper:active .lock-icon {
  transform: scale(0.9);
}

/* Reduce Motion for Accessibility */
@media (prefers-reduced-motion: reduce) {
  .slide-fade-enter-active,
  .slide-fade-leave-active,
  .expand-fade-enter-active,
  .expand-fade-leave-active,
  .requirement-item,
  .strength-bar :deep(.v-progress-linear__determinate),
  .security-tips,
  .tips-list li {
    animation: none;
    transition: none;
  }

  .requirement-item,
  .tips-list li {
    opacity: 1;
    transform: none;
  }
}

/* Hidden/Unused Styles */
.role-selection-container,
.role-radio-group,
.role-card {
  display: none;
}

.action-controls {
  display: flex;
  align-items: center;
  background: rgba(0, 0, 0, 0.02);
  border-radius: 12px;
  padding: 4px 8px;
  border: 1px solid rgba(0, 0, 0, 0.06);
  transition: all 0.2s ease;
  min-width: 300px;
}

.action-controls:hover {
  background: rgba(0, 0, 0, 0.03);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.control-btn {
  margin: 0 4px;
  font-weight: 500;
  letter-spacing: 0.025em;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
}
.template-btn,
.import-btn {
  width: 120px;
  height: 36px;
}
.template-btn:hover {
  background: transparent !important;
  box-shadow: none;
  transform: translate(0);
}

:deep(.v-data-table tbody tr) {
  transition: all 0.2s ease;
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
}

:deep(.v-data-table tbody tr:hover) {
  background: rgba(0, 0, 0, 0.02);
  /* transform: translateY(-1px); */
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

:deep(.v-data-table-header) {
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  border-bottom: 2px solid #dee2e6;
}

:deep(.v-data-table-header th) {
  color: #495057 !important;
  font-weight: 700 !important;
  font-size: 0.875rem !important;
  padding: 1rem !important;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  border-bottom: 2px solid rgba(25, 118, 210, 0.1) !important;
}
</style>
